/* eslint-disable */
const urls = {"sitemap":{"route":"/sitemap/sitemap.xml","args":{}},"sitemap-index":{"route":"/sitemap.xml","args":{}},"thelabui:load-balancer-health-check":{"route":"/admin/load-balancer-ht/","args":{}},"thelabui:csrftoken-get":{"route":"/api-nc/csrftoken/","args":{}},"thelabui:robots-txt":{"route":"/robots.txt","args":{}},"thelabui:security-txt":{"route":"/.well-known/security.txt","args":{}},"thelabui:sitemap":{"route":"/sitemap.xml","args":{}},"wagtailadmin_home":{"route":"/wagtail/","args":{}},"wagtailadmin_api:pages:listing":{"route":"/wagtail/api/main/^pages/","args":{}},"wagtailadmin_api:pages:detail":{"route":"/wagtail/api/main/^pages/<int:pk>/","args":{"pk":"number"}},"wagtailadmin_api:pages:find":{"route":"/wagtail/api/main/^pages/find/","args":{}},"wagtailadmin_api:pages:action":{"route":"/wagtail/api/main/^pages/<int:pk>/action/<str:action_name>/","args":{"pk":"number","action_name":"string"}},"wagtailadmin_api:documents:listing":{"route":"/wagtail/api/main/^documents/","args":{}},"wagtailadmin_api:documents:detail":{"route":"/wagtail/api/main/^documents/<int:pk>/","args":{"pk":"number"}},"wagtailadmin_api:documents:find":{"route":"/wagtail/api/main/^documents/find/","args":{}},"wagtailadmin_api:images:listing":{"route":"/wagtail/api/main/^images/","args":{}},"wagtailadmin_api:images:detail":{"route":"/wagtail/api/main/^images/<int:pk>/","args":{"pk":"number"}},"wagtailadmin_api:images:find":{"route":"/wagtail/api/main/^images/find/","args":{}},"wagtailadmin_error_test":{"route":"/wagtail/failwhale/","args":{}},"wagtailadmin_explore_root":{"route":"/wagtail/pages/","args":{}},"wagtailadmin_explore":{"route":"/wagtail/pages/<int:parent_page_id>/","args":{"parent_page_id":"number"}},"wagtailadmin_explore_results":{"route":"/wagtail/pages/<int:parent_page_id>/results/","args":{"parent_page_id":"number"}},"wagtail_bulk_action":{"route":"/wagtail/bulk/<str:app_label>/<str:model_name>/<str:action>/","args":{"app_label":"string","model_name":"string","action":"string"}},"wagtailadmin_pages:add":{"route":"/wagtail/pages/add/<slug:content_type_app_name>/<slug:content_type_model_name>/<int:parent_page_id>/","args":{"content_type_app_name":"string","content_type_model_name":"string","parent_page_id":"number"}},"wagtailadmin_pages:preview_on_add":{"route":"/wagtail/pages/add/<slug:content_type_app_name>/<slug:content_type_model_name>/<int:parent_page_id>/preview/","args":{"content_type_app_name":"string","content_type_model_name":"string","parent_page_id":"number"}},"wagtailadmin_pages:type_use":{"route":"/wagtail/pages/usage/<slug:content_type_app_name>/<slug:content_type_model_name>/","args":{"content_type_app_name":"string","content_type_model_name":"string"}},"wagtailadmin_pages:type_use_results":{"route":"/wagtail/pages/usage/<slug:content_type_app_name>/<slug:content_type_model_name>/results/","args":{"content_type_app_name":"string","content_type_model_name":"string"}},"wagtailadmin_pages:usage":{"route":"/wagtail/pages/<int:page_id>/usage/","args":{"page_id":"number"}},"wagtailadmin_pages:edit":{"route":"/wagtail/pages/<int:page_id>/edit/","args":{"page_id":"number"}},"wagtailadmin_pages:preview_on_edit":{"route":"/wagtail/pages/<int:page_id>/edit/preview/","args":{"page_id":"number"}},"wagtailadmin_pages:view_draft":{"route":"/wagtail/pages/<int:page_id>/view_draft/","args":{"page_id":"number"}},"wagtailadmin_pages:add_subpage":{"route":"/wagtail/pages/<int:parent_page_id>/add_subpage/","args":{"parent_page_id":"number"}},"wagtailadmin_pages:delete":{"route":"/wagtail/pages/<int:page_id>/delete/","args":{"page_id":"number"}},"wagtailadmin_pages:unpublish":{"route":"/wagtail/pages/<int:page_id>/unpublish/","args":{"page_id":"number"}},"wagtailadmin_pages:convert_alias":{"route":"/wagtail/pages/<int:page_id>/convert_alias/","args":{"page_id":"number"}},"wagtailadmin_pages:search":{"route":"/wagtail/pages/search/","args":{}},"wagtailadmin_pages:search_results":{"route":"/wagtail/pages/search/results/","args":{}},"wagtailadmin_pages:move":{"route":"/wagtail/pages/<int:page_to_move_id>/move/","args":{"page_to_move_id":"number"}},"wagtailadmin_pages:move_confirm":{"route":"/wagtail/pages/<int:page_to_move_id>/move/<int:destination_id>/confirm/","args":{"page_to_move_id":"number","destination_id":"number"}},"wagtailadmin_pages:set_page_position":{"route":"/wagtail/pages/<int:page_to_move_id>/set_position/","args":{"page_to_move_id":"number"}},"wagtailadmin_pages:copy":{"route":"/wagtail/pages/<int:page_id>/copy/","args":{"page_id":"number"}},"wagtailadmin_pages:workflow_action":{"route":"/wagtail/pages/workflow/action/<int:page_id>/<slug:action_name>/<int:task_state_id>/","args":{"page_id":"number","action_name":"string","task_state_id":"number"}},"wagtailadmin_pages:collect_workflow_action_data":{"route":"/wagtail/pages/workflow/collect_action_data/<int:page_id>/<slug:action_name>/<int:task_state_id>/","args":{"page_id":"number","action_name":"string","task_state_id":"number"}},"wagtailadmin_pages:confirm_workflow_cancellation":{"route":"/wagtail/pages/workflow/confirm_cancellation/<int:page_id>/","args":{"page_id":"number"}},"wagtailadmin_pages:workflow_preview":{"route":"/wagtail/pages/workflow/preview/<int:page_id>/<int:task_id>/","args":{"page_id":"number","task_id":"number"}},"wagtailadmin_pages:set_privacy":{"route":"/wagtail/pages/<int:page_id>/privacy/","args":{"page_id":"number"}},"wagtailadmin_pages:lock":{"route":"/wagtail/pages/<int:page_id>/lock/","args":{"page_id":"number"}},"wagtailadmin_pages:unlock":{"route":"/wagtail/pages/<int:page_id>/unlock/","args":{"page_id":"number"}},"wagtailadmin_pages:revisions_index":{"route":"/wagtail/pages/<int:page_id>/revisions/","args":{"page_id":"number"}},"wagtailadmin_pages:revisions_view":{"route":"/wagtail/pages/<int:page_id>/revisions/<int:revision_id>/view/","args":{"page_id":"number","revision_id":"number"}},"wagtailadmin_pages:revisions_revert":{"route":"/wagtail/pages/<int:page_id>/revisions/<int:revision_id>/revert/","args":{"page_id":"number","revision_id":"number"}},"wagtailadmin_pages:revisions_unschedule":{"route":"/wagtail/pages/<int:page_id>/revisions/<int:revision_id>/unschedule/","args":{"page_id":"number","revision_id":"number"}},"wagtailadmin_pages:workflow_history":{"route":"/wagtail/pages/<int:page_id>/workflow_history/","args":{"page_id":"number"}},"wagtailadmin_pages:workflow_history_detail":{"route":"/wagtail/pages/<int:page_id>/workflow_history/detail/<int:workflow_state_id>/","args":{"page_id":"number","workflow_state_id":"number"}},"wagtailadmin_pages:history":{"route":"/wagtail/pages/<int:page_id>/history/","args":{"page_id":"number"}},"wagtailadmin_pages:history_results":{"route":"/wagtail/pages/<int:page_id>/history/results/","args":{"page_id":"number"}},"wagtailadmin_choose_page":{"route":"/wagtail/choose-page/","args":{}},"wagtailadmin_choose_page_child":{"route":"/wagtail/choose-page/<int:parent_page_id>/","args":{"parent_page_id":"number"}},"wagtailadmin_choose_page_search":{"route":"/wagtail/choose-page/search/","args":{}},"wagtailadmin_choose_page_chosen_multiple":{"route":"/wagtail/choose-page/chosen-multiple/","args":{}},"wagtailadmin_choose_page_external_link":{"route":"/wagtail/choose-external-link/","args":{}},"wagtailadmin_choose_page_email_link":{"route":"/choose-email-link/","args":{}},"wagtailadmin_choose_page_phone_link":{"route":"/wagtail/choose-phone-link/","args":{}},"wagtailadmin_choose_page_anchor_link":{"route":"/wagtail/choose-anchor-link/","args":{}},"wagtailadmin_tag_autocomplete":{"route":"/wagtail/tag-autocomplete/","args":{}},"wagtailadmin_tag_model_autocomplete":{"route":"/wagtail/tag-autocomplete/<slug:app_name>/<slug:model_name>/","args":{"app_name":"string","model_name":"string"}},"wagtailadmin_collections:index":{"route":"/wagtail/collections/","args":{}},"wagtailadmin_collections:add":{"route":"/wagtail/collections/add/","args":{}},"wagtailadmin_collections:edit":{"route":"/wagtail/collections/<int:pk>/","args":{"pk":"number"}},"wagtailadmin_collections:delete":{"route":"/wagtail/collections/<int:pk>/delete/","args":{"pk":"number"}},"wagtailadmin_collections:set_privacy":{"route":"/wagtail/collections/<int:collection_id>/privacy/","args":{"collection_id":"number"}},"wagtailadmin_workflows:index":{"route":"/wagtail/workflows/list/","args":{}},"wagtailadmin_workflows:index_results":{"route":"/wagtail/workflows/list/results/","args":{}},"wagtailadmin_workflows:add":{"route":"/wagtail/workflows/add/","args":{}},"wagtailadmin_workflows:enable":{"route":"/wagtail/workflows/enable/<int:pk>/","args":{"pk":"number"}},"wagtailadmin_workflows:disable":{"route":"/wagtail/workflows/disable/<int:pk>/","args":{"pk":"number"}},"wagtailadmin_workflows:edit":{"route":"/wagtail/workflows/edit/<int:pk>/","args":{"pk":"number"}},"wagtailadmin_workflows:usage":{"route":"/wagtail/workflows/usage/<int:pk>/","args":{"pk":"number"}},"wagtailadmin_workflows:usage_results":{"route":"/wagtail/workflows/usage/<int:pk>/results/","args":{"pk":"number"}},"wagtailadmin_workflows:remove":{"route":"/wagtail/workflows/remove/<int:page_pk>/<int:workflow_pk>/","args":{"page_pk":"number","workflow_pk":"number"}},"wagtailadmin_workflows:add_task":{"route":"/wagtail/workflows/tasks/add/<str:app_label>/<str:model_name>/","args":{"app_label":"string","model_name":"string"}},"wagtailadmin_workflows:select_task_type":{"route":"/wagtail/workflows/tasks/select_type/","args":{}},"wagtailadmin_workflows:task_index":{"route":"/wagtail/workflows/tasks/index/","args":{}},"wagtailadmin_workflows:task_index_results":{"route":"/wagtail/workflows/tasks/index/results/","args":{}},"wagtailadmin_workflows:edit_task":{"route":"/wagtail/workflows/tasks/edit/<int:pk>/","args":{"pk":"number"}},"wagtailadmin_workflows:disable_task":{"route":"/wagtail/workflows/tasks/disable/<int:pk>/","args":{"pk":"number"}},"wagtailadmin_workflows:enable_task":{"route":"/wagtail/workflows/tasks/enable/<int:pk>/","args":{"pk":"number"}},"wagtailadmin_workflows:task_chooser":{"route":"/wagtail/workflows/task_chooser/","args":{}},"wagtailadmin_workflows:task_chooser_results":{"route":"/wagtail/workflows/task_chooser/results/","args":{}},"wagtailadmin_workflows:task_chooser_create":{"route":"/wagtail/workflows/task_chooser/create/","args":{}},"wagtailadmin_workflows:task_chosen":{"route":"/wagtail/workflows/task_chooser/<int:task_id>/","args":{"task_id":"number"}},"wagtailadmin_reports:locked_pages":{"route":"/wagtail/reports/locked/","args":{}},"wagtailadmin_reports:locked_pages_results":{"route":"/wagtail/reports/locked/results/","args":{}},"wagtailadmin_reports:workflow":{"route":"/wagtail/reports/workflow/","args":{}},"wagtailadmin_reports:workflow_results":{"route":"/wagtail/reports/workflow/results/","args":{}},"wagtailadmin_reports:workflow_tasks":{"route":"/wagtail/reports/workflow_tasks/","args":{}},"wagtailadmin_reports:workflow_tasks_results":{"route":"/wagtail/reports/workflow_tasks/results/","args":{}},"wagtailadmin_reports:site_history":{"route":"/wagtail/reports/site-history/","args":{}},"wagtailadmin_reports:site_history_results":{"route":"/wagtail/reports/site-history/results/","args":{}},"wagtailadmin_reports:aging_pages":{"route":"/wagtail/reports/aging-pages/","args":{}},"wagtailadmin_reports:aging_pages_results":{"route":"/wagtail/reports/aging-pages/results/","args":{}},"wagtailadmin_reports:page_types_usage":{"route":"/wagtail/reports/page-types-usage/","args":{}},"wagtailadmin_reports:page_types_usage_results":{"route":"/wagtail/reports/page-types-usage/results/","args":{}},"wagtailadmin_account":{"route":"/wagtail/account/","args":{}},"wagtailadmin_logout":{"route":"/wagtail/logout/","args":{}},"wagtailadmin_dismissibles":{"route":"/wagtail/dismissibles/","args":{}},"wagtailadmin_editing_sessions:ping":{"route":"/wagtail/editing-sessions/ping/<str:app_label>/<str:model_name>/<str:object_id>/<int:session_id>/","args":{"app_label":"string","model_name":"string","object_id":"string","session_id":"number"}},"wagtailadmin_editing_sessions:release":{"route":"/wagtail/editing-sessions/release/<int:session_id>/","args":{"session_id":"number"}},"wagtailadmin_block_preview":{"route":"/wagtail/block-preview/","args":{}},"wagtailforms:index":{"route":"/wagtail/forms/","args":{}},"wagtailforms:index_results":{"route":"/wagtail/forms/results/","args":{}},"wagtailforms:list_submissions":{"route":"/wagtail/forms/submissions/<int:page_id>/","args":{"page_id":"number"}},"wagtailforms:list_submissions_results":{"route":"/wagtail/forms/submissions/<int:page_id>/results/","args":{"page_id":"number"}},"wagtailforms:delete_submissions":{"route":"/wagtail/forms/submissions/<int:page_id>/delete/","args":{"page_id":"number"}},"wagtailredirects:index":{"route":"/wagtail/redirects/","args":{}},"wagtailredirects:index_results":{"route":"/wagtail/redirects/results/","args":{}},"wagtailredirects:add":{"route":"/wagtail/redirects/add/","args":{}},"wagtailredirects:edit":{"route":"/wagtail/redirects/<int:redirect_id>/","args":{"redirect_id":"number"}},"wagtailredirects:delete":{"route":"/wagtail/redirects/<int:redirect_id>/delete/","args":{"redirect_id":"number"}},"wagtailredirects:start_import":{"route":"/wagtail/redirects/import/","args":{}},"wagtailredirects:process_import":{"route":"/wagtail/redirects/import/process/","args":{}},"wagtailsettings:edit":{"route":"/wagtail/settings/<slug:app_name>/<slug:model_name>/<int:pk>/","args":{"app_name":"string","model_name":"string","pk":"number"}},"wagtailstyleguide":{"route":"/wagtail/styleguide/","args":{}},"wagtailembeds:chooser":{"route":"/wagtail/embeds/chooser/","args":{}},"wagtailembeds:chooser_upload":{"route":"/wagtail/embeds/chooser/upload/","args":{}},"wagtailsnippets:index":{"route":"/wagtail/snippets/","args":{}},"wagtaildocs:index":{"route":"/wagtail/documents/","args":{}},"wagtaildocs:index_results":{"route":"/wagtail/documents/results/","args":{}},"wagtaildocs:add":{"route":"/wagtail/documents/add/","args":{}},"wagtaildocs:edit":{"route":"/wagtail/documents/edit/<int:document_id>/","args":{"document_id":"number"}},"wagtaildocs:delete":{"route":"/wagtail/documents/delete/<int:document_id>/","args":{"document_id":"number"}},"wagtaildocs:add_multiple":{"route":"/wagtail/documents/multiple/add/","args":{}},"wagtaildocs:edit_multiple":{"route":"/wagtail/documents/multiple/<int:doc_id>/","args":{"doc_id":"number"}},"wagtaildocs:create_multiple_from_uploaded_document":{"route":"/wagtail/documents/multiple/create_from_uploaded_document/<int:uploaded_file_id>/","args":{"uploaded_file_id":"number"}},"wagtaildocs:delete_multiple":{"route":"/wagtail/documents/multiple/<int:doc_id>/delete/","args":{"doc_id":"number"}},"wagtaildocs:delete_upload_multiple":{"route":"/wagtail/documents/multiple/delete_upload/<int:uploaded_file_id>/","args":{"uploaded_file_id":"number"}},"wagtaildocs:document_usage":{"route":"/wagtail/documents/usage/<int:document_id>/","args":{"document_id":"number"}},"wagtailimages:index":{"route":"/wagtail/images/","args":{}},"wagtailimages:index_results":{"route":"/wagtail/images/results/","args":{}},"wagtailimages:edit":{"route":"/wagtail/images/<int:image_id>/","args":{"image_id":"number"}},"wagtailimages:delete":{"route":"/wagtail/images/<int:image_id>/delete/","args":{"image_id":"number"}},"wagtailimages:url_generator":{"route":"/wagtail/images/<int:image_id>/generate_url/","args":{"image_id":"number"}},"wagtailimages:generate_url":{"route":"/wagtail/images/<int:image_id>/generate_url/<str:filter_spec>/","args":{"image_id":"number","filter_spec":"string"}},"wagtailimages:preview":{"route":"/wagtail/images/<int:image_id>/preview/<str:filter_spec>/","args":{"image_id":"number","filter_spec":"string"}},"wagtailimages:add":{"route":"/wagtail/images/add/","args":{}},"wagtailimages:image_usage":{"route":"/wagtail/images/usage/<int:image_id>/","args":{"image_id":"number"}},"wagtailimages:add_multiple":{"route":"/wagtail/images/multiple/add/","args":{}},"wagtailimages:edit_multiple":{"route":"/wagtail/images/multiple/<int:image_id>/","args":{"image_id":"number"}},"wagtailimages:create_multiple_from_uploaded_image":{"route":"/wagtail/images/multiple/create_from_uploaded_image/<int:uploaded_file_id>/","args":{"uploaded_file_id":"number"}},"wagtailimages:delete_multiple":{"route":"/wagtail/images/multiple/<int:image_id>/delete/","args":{"image_id":"number"}},"wagtailimages:delete_upload_multiple":{"route":"/wagtail/images/multiple/delete_upload/<int:uploaded_file_id>/","args":{"uploaded_file_id":"number"}},"wagtailsnippets_thelabui_labuitoolboxsnippet:list":{"route":"/wagtail/snippets/thelabui/labuitoolboxsnippet/","args":{}},"wagtailsnippets_thelabui_labuitoolboxsnippet:list_results":{"route":"/wagtail/snippets/thelabui/labuitoolboxsnippet/results/","args":{}},"wagtailsnippets_thelabui_labuitoolboxsnippet:add":{"route":"/wagtail/snippets/thelabui/labuitoolboxsnippet/add/","args":{}},"wagtailsnippets_thelabui_labuitoolboxsnippet:edit":{"route":"/wagtail/snippets/thelabui/labuitoolboxsnippet/edit/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_thelabui_labuitoolboxsnippet:delete":{"route":"/wagtail/snippets/thelabui/labuitoolboxsnippet/delete/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_thelabui_labuitoolboxsnippet:usage":{"route":"/wagtail/snippets/thelabui/labuitoolboxsnippet/usage/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_thelabui_labuitoolboxsnippet:history":{"route":"/wagtail/snippets/thelabui/labuitoolboxsnippet/history/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_thelabui_labuitoolboxsnippet:history_results":{"route":"/wagtail/snippets/thelabui/labuitoolboxsnippet/history-results/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_thelabui_labuitoolboxsnippet:copy":{"route":"/wagtail/snippets/thelabui/labuitoolboxsnippet/copy/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_thelabui_labuitoolboxsnippet:preview_on_add":{"route":"/wagtail/snippets/thelabui/labuitoolboxsnippet/preview/","args":{}},"wagtailsnippets_thelabui_labuitoolboxsnippet:preview_on_edit":{"route":"/wagtail/snippets/thelabui/labuitoolboxsnippet/preview/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_thelabui_labuitoolboxsnippet:revisions_view":{"route":"/wagtail/snippets/thelabui/labuitoolboxsnippet/history/<str:pk>/revisions/<int:revision_id>/view/","args":{"pk":"string","revision_id":"number"}},"wagtailsnippets_thelabui_labuitoolboxsnippet:revisions_revert":{"route":"/wagtail/snippets/thelabui/labuitoolboxsnippet/history/<str:pk>/revisions/<int:revision_id>/revert/","args":{"pk":"string","revision_id":"number"}},"wagtailsnippets_thelabui_labuitoolboxsnippet:revisions_unschedule":{"route":"/wagtail/snippets/thelabui/labuitoolboxsnippet/history/<str:pk>/revisions/<int:revision_id>/unschedule/","args":{"pk":"string","revision_id":"number"}},"wagtailsnippets_thelabui_labuitoolboxsnippet:unpublish":{"route":"/wagtail/snippets/thelabui/labuitoolboxsnippet/unpublish/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_thelabui_labuitoolboxsnippet:lock":{"route":"/wagtail/snippets/thelabui/labuitoolboxsnippet/lock/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_thelabui_labuitoolboxsnippet:unlock":{"route":"/wagtail/snippets/thelabui/labuitoolboxsnippet/unlock/<str:pk>/","args":{"pk":"string"}},"wagtailsnippetchoosers_thelabui_labuitoolboxsnippet:choose":{"route":"/wagtail/snippets/choose/thelabui/labuitoolboxsnippet/","args":{}},"wagtailsnippetchoosers_thelabui_labuitoolboxsnippet:choose_results":{"route":"/wagtail/snippets/choose/thelabui/labuitoolboxsnippet/results/","args":{}},"wagtailsnippetchoosers_thelabui_labuitoolboxsnippet:chosen":{"route":"/wagtail/snippets/choose/thelabui/labuitoolboxsnippet/chosen/<str:pk>/","args":{"pk":"string"}},"wagtailsnippetchoosers_thelabui_labuitoolboxsnippet:chosen_multiple":{"route":"/wagtail/snippets/choose/thelabui/labuitoolboxsnippet/chosen-multiple/","args":{}},"wagtailsnippetchoosers_thelabui_labuitoolboxsnippet:create":{"route":"/wagtail/snippets/choose/thelabui/labuitoolboxsnippet/create/","args":{}},"wagtailsnippets_locations_country:list":{"route":"/wagtail/snippets/locations/country/","args":{}},"wagtailsnippets_locations_country:list_results":{"route":"/wagtail/snippets/locations/country/results/","args":{}},"wagtailsnippets_locations_country:add":{"route":"/wagtail/snippets/locations/country/add/","args":{}},"wagtailsnippets_locations_country:edit":{"route":"/wagtail/snippets/locations/country/edit/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_locations_country:delete":{"route":"/wagtail/snippets/locations/country/delete/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_locations_country:usage":{"route":"/wagtail/snippets/locations/country/usage/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_locations_country:history":{"route":"/wagtail/snippets/locations/country/history/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_locations_country:history_results":{"route":"/wagtail/snippets/locations/country/history-results/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_locations_country:copy":{"route":"/wagtail/snippets/locations/country/copy/<str:pk>/","args":{"pk":"string"}},"wagtailsnippetchoosers_locations_country:choose":{"route":"/wagtail/snippets/choose/locations/country/","args":{}},"wagtailsnippetchoosers_locations_country:choose_results":{"route":"/wagtail/snippets/choose/locations/country/results/","args":{}},"wagtailsnippetchoosers_locations_country:chosen":{"route":"/wagtail/snippets/choose/locations/country/chosen/<str:pk>/","args":{"pk":"string"}},"wagtailsnippetchoosers_locations_country:chosen_multiple":{"route":"/wagtail/snippets/choose/locations/country/chosen-multiple/","args":{}},"wagtailsnippetchoosers_locations_country:create":{"route":"/wagtail/snippets/choose/locations/country/create/","args":{}},"wagtailsnippets_cms_tierednav:list":{"route":"/wagtail/snippets/cms/tierednav/","args":{}},"wagtailsnippets_cms_tierednav:list_results":{"route":"/wagtail/snippets/cms/tierednav/results/","args":{}},"wagtailsnippets_cms_tierednav:add":{"route":"/wagtail/snippets/cms/tierednav/add/","args":{}},"wagtailsnippets_cms_tierednav:edit":{"route":"/wagtail/snippets/cms/tierednav/edit/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_cms_tierednav:delete":{"route":"/wagtail/snippets/cms/tierednav/delete/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_cms_tierednav:usage":{"route":"/wagtail/snippets/cms/tierednav/usage/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_cms_tierednav:history":{"route":"/wagtail/snippets/cms/tierednav/history/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_cms_tierednav:history_results":{"route":"/wagtail/snippets/cms/tierednav/history-results/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_cms_tierednav:copy":{"route":"/wagtail/snippets/cms/tierednav/copy/<str:pk>/","args":{"pk":"string"}},"wagtailsnippetchoosers_cms_tierednav:choose":{"route":"/wagtail/snippets/choose/cms/tierednav/","args":{}},"wagtailsnippetchoosers_cms_tierednav:choose_results":{"route":"/wagtail/snippets/choose/cms/tierednav/results/","args":{}},"wagtailsnippetchoosers_cms_tierednav:chosen":{"route":"/wagtail/snippets/choose/cms/tierednav/chosen/<str:pk>/","args":{"pk":"string"}},"wagtailsnippetchoosers_cms_tierednav:chosen_multiple":{"route":"/wagtail/snippets/choose/cms/tierednav/chosen-multiple/","args":{}},"wagtailsnippetchoosers_cms_tierednav:create":{"route":"/wagtail/snippets/choose/cms/tierednav/create/","args":{}},"wagtailsites:index":{"route":"/wagtail/sites/","args":{}},"wagtailsites:index_results":{"route":"/wagtail/sites/results/","args":{}},"wagtailsites:add":{"route":"/wagtail/sites/new/","args":{}},"wagtailsites:edit":{"route":"/wagtail/sites/edit/<str:pk>/","args":{"pk":"string"}},"wagtailsites:delete":{"route":"/wagtail/sites/delete/<str:pk>/","args":{"pk":"string"}},"wagtailsites:history":{"route":"/wagtail/sites/history/<str:pk>/","args":{"pk":"string"}},"wagtailsites:history_results":{"route":"/wagtail/sites/history-results/<str:pk>/","args":{"pk":"string"}},"wagtailsites:usage":{"route":"/wagtail/sites/usage/<str:pk>/","args":{"pk":"string"}},"wagtailsites:copy":{"route":"/wagtail/sites/copy/<str:pk>/","args":{"pk":"string"}},"wagtailusers_users:index":{"route":"/wagtail/users/","args":{}},"wagtailusers_users:index_results":{"route":"/wagtail/users/results/","args":{}},"wagtailusers_users:add":{"route":"/wagtail/users/new/","args":{}},"wagtailusers_users:edit":{"route":"/wagtail/users/edit/<str:pk>/","args":{"pk":"string"}},"wagtailusers_users:delete":{"route":"/wagtail/users/delete/<str:pk>/","args":{"pk":"string"}},"wagtailusers_users:history":{"route":"/wagtail/users/history/<str:pk>/","args":{"pk":"string"}},"wagtailusers_users:history_results":{"route":"/wagtail/users/history-results/<str:pk>/","args":{"pk":"string"}},"wagtailusers_users:usage":{"route":"/wagtail/users/usage/<str:pk>/","args":{"pk":"string"}},"wagtailusers_users:copy":{"route":"/wagtail/users/copy/<str:pk>/","args":{"pk":"string"}},"wagtailusers_groups:index":{"route":"/wagtail/groups/","args":{}},"wagtailusers_groups:index_results":{"route":"/wagtail/groups/results/","args":{}},"wagtailusers_groups:add":{"route":"/wagtail/groups/new/","args":{}},"wagtailusers_groups:edit":{"route":"/wagtail/groups/edit/<str:pk>/","args":{"pk":"string"}},"wagtailusers_groups:delete":{"route":"/wagtail/groups/delete/<str:pk>/","args":{"pk":"string"}},"wagtailusers_groups:history":{"route":"/wagtail/groups/history/<str:pk>/","args":{"pk":"string"}},"wagtailusers_groups:history_results":{"route":"/wagtail/groups/history-results/<str:pk>/","args":{"pk":"string"}},"wagtailusers_groups:usage":{"route":"/wagtail/groups/usage/<str:pk>/","args":{"pk":"string"}},"wagtaildocs_chooser:choose":{"route":"/wagtail/documents/chooser/","args":{}},"wagtaildocs_chooser:choose_results":{"route":"/wagtail/documents/chooser/results/","args":{}},"wagtaildocs_chooser:chosen":{"route":"/wagtail/documents/chooser/chosen/<str:pk>/","args":{"pk":"string"}},"wagtaildocs_chooser:chosen_multiple":{"route":"/wagtail/documents/chooser/chosen-multiple/","args":{}},"wagtaildocs_chooser:create":{"route":"/wagtail/documents/chooser/create/","args":{}},"wagtailimages_chooser:choose":{"route":"/wagtail/images/chooser/","args":{}},"wagtailimages_chooser:choose_results":{"route":"/wagtail/images/chooser/results/","args":{}},"wagtailimages_chooser:chosen":{"route":"/wagtail/images/chooser/chosen/<str:pk>/","args":{"pk":"string"}},"wagtailimages_chooser:chosen_multiple":{"route":"/wagtail/images/chooser/chosen-multiple/","args":{}},"wagtailimages_chooser:create":{"route":"/wagtail/images/chooser/create/","args":{}},"wagtailimages_chooser:select_format":{"route":"/wagtail/images/chooser/<int:image_id>/select_format/","args":{"image_id":"number"}},"wagtailvideos_chooser:choose":{"route":"/wagtail/videos/chooser/","args":{}},"wagtailvideos_chooser:choose_results":{"route":"/wagtail/videos/chooser/results/","args":{}},"wagtailvideos_chooser:chosen":{"route":"/wagtail/videos/chooser/chosen/<str:pk>/","args":{"pk":"string"}},"wagtailvideos_chooser:chosen_multiple":{"route":"/wagtail/videos/chooser/chosen-multiple/","args":{}},"wagtailvideos_chooser:create":{"route":"/wagtail/videos/chooser/create/","args":{}},"wagtailvideos:add":{"route":"/wagtail/videos/add/","args":{}},"wagtailvideos:add_multiple":{"route":"/wagtail/videos/multiple/add/","args":{}},"wagtailvideos:edit_multiple":{"route":"/wagtail/videos/multiple/<int:video_id>/","args":{"video_id":"number"}},"wagtailvideos:create_multiple_from_uploaded_image":{"route":"/wagtail/videos/multiple/create_from_uploaded_image/<int:uploaded_file_id>/","args":{"uploaded_file_id":"number"}},"wagtailvideos:delete_multiple":{"route":"/wagtail/videos/multiple/<int:video_id>/delete/","args":{"video_id":"number"}},"wagtailvideos:delete_upload_multiple":{"route":"/wagtail/videos/multiple/delete_upload/<int:uploaded_file_id>/","args":{"uploaded_file_id":"number"}},"wagtailvideos:index":{"route":"/wagtail/videos/","args":{}},"wagtailvideos:index_results":{"route":"/wagtail/videos/results/","args":{}},"wagtail_modeladmin:javascript_catalog":{"route":"/wagtail/modeladmin/jsi18n/","args":{}},"wagtailadmin_sprite":{"route":"/wagtail/sprite/","args":{}},"wagtailadmin_login":{"route":"/wagtail/login/","args":{}},"wagtailadmin_password_reset":{"route":"/wagtail/password_reset/","args":{}},"wagtailadmin_password_reset_done":{"route":"/wagtail/password_reset/done/","args":{}},"wagtailadmin_password_reset_confirm":{"route":"/wagtail/password_reset/confirm/<uidb64>/<token>/","args":{"uidb64":"string","token":"string"}},"wagtailadmin_password_reset_complete":{"route":"/wagtail/password_reset/complete/","args":{}},"wagtailadmin_javascript_catalog":{"route":"/wagtail/jsi18n/","args":{}},"health_check:health_check_home":{"route":"/api/ht/","args":{}},"health_check:health_check_subset":{"route":"/api/ht/<str:subset>/","args":{"subset":"string"}},"locations-api:locationlist":{"route":"/api/location/getlocations/","args":{}},"locations-api:locationdetail":{"route":"/api/location/getlocation/","args":{}},"locations-api:waitlistdetail":{"route":"/api/location/getwaitlist/","args":{}},"locations-api:flush":{"route":"/api/location/flush/","args":{}},"locations-api:waitlist-join":{"route":"/api/waitlist/","args":{}},"locations-api:waitlist-getestimate":{"route":"/api/waitlist/estimate/","args":{}},"locations-api:waitlist-entry":{"route":"/api/waitlist/<str:plan_ahead_id>/","args":{"plan_ahead_id":"string"}},"locations-api:locationlist-alt":{"route":"/api/location/getlocations","args":{}},"locations-api:locationdetail-alt":{"route":"/api/location/getlocation","args":{}},"locations-api:waitlistdetail-alt":{"route":"/api/location/getwaitlist","args":{}},"locations-api:flush-alt":{"route":"/api/location/flush","args":{}},"locations-api:waitlist-join-alt":{"route":"/api/waitlist","args":{}},"locations-api:waitlist-getestimate-alt":{"route":"/api/waitlist/estimate","args":{}},"locations-api:waitlist-entry-alt":{"route":"/api/waitlist/<str:plan_ahead_id>","args":{"plan_ahead_id":"string"}},"locations:locationredirect":{"route":"/locations/list/<slug:state_slug>/<slug:city_slug>/<slug:line1_slug>/","args":{"state_slug":"string","city_slug":"string","line1_slug":"string"}},"api-fcc-unsubscribe":{"route":"/api/fcc/unsubscribe/","args":{}},"site-footer":{"route":"/blocks/footer/","args":{}},"videotrack-serve":{"route":"/video-track/<int:pk>/","args":{"pk":"number"}},"error-404":{"route":"/error-pages/404/","args":{}},"integration-manifest":{"route":"/integration-manifest.json","args":{}},"google-verification":{"route":"/googlee6c2dac284a20cca.html","args":{}},"wagtailcore_authenticate_with_password":{"route":"/_util/authenticate_with_password/<int:page_view_restriction_id>/<int:page_id>/","args":{"page_view_restriction_id":"number","page_id":"number"}},"wagtailcore_login":{"route":"/_util/login/","args":{}},"__reactivated_do_not_use":{"route":"__reactivated_do_not_use","args":{}},"__reactivated_do_not_use_args":{"route":"__reactivated_do_not_use_args","args":{"_":"string"}}};

interface URLMap {
    sitemap: sitemap;
    sitemap_index: sitemap_index;
    thelabui_load_balancer_health_check: thelabui_load_balancer_health_check;
    thelabui_csrftoken_get: thelabui_csrftoken_get;
    thelabui_robots_txt: thelabui_robots_txt;
    thelabui_security_txt: thelabui_security_txt;
    thelabui_sitemap: thelabui_sitemap;
    wagtailadmin_home: wagtailadmin_home;
    wagtailadmin_api_pages_listing: wagtailadmin_api_pages_listing;
    wagtailadmin_api_pages_detail: wagtailadmin_api_pages_detail;
    wagtailadmin_api_pages_find: wagtailadmin_api_pages_find;
    wagtailadmin_api_pages_action: wagtailadmin_api_pages_action;
    wagtailadmin_api_documents_listing: wagtailadmin_api_documents_listing;
    wagtailadmin_api_documents_detail: wagtailadmin_api_documents_detail;
    wagtailadmin_api_documents_find: wagtailadmin_api_documents_find;
    wagtailadmin_api_images_listing: wagtailadmin_api_images_listing;
    wagtailadmin_api_images_detail: wagtailadmin_api_images_detail;
    wagtailadmin_api_images_find: wagtailadmin_api_images_find;
    wagtailadmin_error_test: wagtailadmin_error_test;
    wagtailadmin_explore_root: wagtailadmin_explore_root;
    wagtailadmin_explore: wagtailadmin_explore;
    wagtailadmin_explore_results: wagtailadmin_explore_results;
    wagtail_bulk_action: wagtail_bulk_action;
    wagtailadmin_pages_add: wagtailadmin_pages_add;
    wagtailadmin_pages_preview_on_add: wagtailadmin_pages_preview_on_add;
    wagtailadmin_pages_type_use: wagtailadmin_pages_type_use;
    wagtailadmin_pages_type_use_results: wagtailadmin_pages_type_use_results;
    wagtailadmin_pages_usage: wagtailadmin_pages_usage;
    wagtailadmin_pages_edit: wagtailadmin_pages_edit;
    wagtailadmin_pages_preview_on_edit: wagtailadmin_pages_preview_on_edit;
    wagtailadmin_pages_view_draft: wagtailadmin_pages_view_draft;
    wagtailadmin_pages_add_subpage: wagtailadmin_pages_add_subpage;
    wagtailadmin_pages_delete: wagtailadmin_pages_delete;
    wagtailadmin_pages_unpublish: wagtailadmin_pages_unpublish;
    wagtailadmin_pages_convert_alias: wagtailadmin_pages_convert_alias;
    wagtailadmin_pages_search: wagtailadmin_pages_search;
    wagtailadmin_pages_search_results: wagtailadmin_pages_search_results;
    wagtailadmin_pages_move: wagtailadmin_pages_move;
    wagtailadmin_pages_move_confirm: wagtailadmin_pages_move_confirm;
    wagtailadmin_pages_set_page_position: wagtailadmin_pages_set_page_position;
    wagtailadmin_pages_copy: wagtailadmin_pages_copy;
    wagtailadmin_pages_workflow_action: wagtailadmin_pages_workflow_action;
    wagtailadmin_pages_collect_workflow_action_data: wagtailadmin_pages_collect_workflow_action_data;
    wagtailadmin_pages_confirm_workflow_cancellation: wagtailadmin_pages_confirm_workflow_cancellation;
    wagtailadmin_pages_workflow_preview: wagtailadmin_pages_workflow_preview;
    wagtailadmin_pages_set_privacy: wagtailadmin_pages_set_privacy;
    wagtailadmin_pages_lock: wagtailadmin_pages_lock;
    wagtailadmin_pages_unlock: wagtailadmin_pages_unlock;
    wagtailadmin_pages_revisions_index: wagtailadmin_pages_revisions_index;
    wagtailadmin_pages_revisions_view: wagtailadmin_pages_revisions_view;
    wagtailadmin_pages_revisions_revert: wagtailadmin_pages_revisions_revert;
    wagtailadmin_pages_revisions_unschedule: wagtailadmin_pages_revisions_unschedule;
    wagtailadmin_pages_workflow_history: wagtailadmin_pages_workflow_history;
    wagtailadmin_pages_workflow_history_detail: wagtailadmin_pages_workflow_history_detail;
    wagtailadmin_pages_history: wagtailadmin_pages_history;
    wagtailadmin_pages_history_results: wagtailadmin_pages_history_results;
    wagtailadmin_choose_page: wagtailadmin_choose_page;
    wagtailadmin_choose_page_child: wagtailadmin_choose_page_child;
    wagtailadmin_choose_page_search: wagtailadmin_choose_page_search;
    wagtailadmin_choose_page_chosen_multiple: wagtailadmin_choose_page_chosen_multiple;
    wagtailadmin_choose_page_external_link: wagtailadmin_choose_page_external_link;
    wagtailadmin_choose_page_email_link: wagtailadmin_choose_page_email_link;
    wagtailadmin_choose_page_phone_link: wagtailadmin_choose_page_phone_link;
    wagtailadmin_choose_page_anchor_link: wagtailadmin_choose_page_anchor_link;
    wagtailadmin_tag_autocomplete: wagtailadmin_tag_autocomplete;
    wagtailadmin_tag_model_autocomplete: wagtailadmin_tag_model_autocomplete;
    wagtailadmin_collections_index: wagtailadmin_collections_index;
    wagtailadmin_collections_add: wagtailadmin_collections_add;
    wagtailadmin_collections_edit: wagtailadmin_collections_edit;
    wagtailadmin_collections_delete: wagtailadmin_collections_delete;
    wagtailadmin_collections_set_privacy: wagtailadmin_collections_set_privacy;
    wagtailadmin_workflows_index: wagtailadmin_workflows_index;
    wagtailadmin_workflows_index_results: wagtailadmin_workflows_index_results;
    wagtailadmin_workflows_add: wagtailadmin_workflows_add;
    wagtailadmin_workflows_enable: wagtailadmin_workflows_enable;
    wagtailadmin_workflows_disable: wagtailadmin_workflows_disable;
    wagtailadmin_workflows_edit: wagtailadmin_workflows_edit;
    wagtailadmin_workflows_usage: wagtailadmin_workflows_usage;
    wagtailadmin_workflows_usage_results: wagtailadmin_workflows_usage_results;
    wagtailadmin_workflows_remove: wagtailadmin_workflows_remove;
    wagtailadmin_workflows_add_task: wagtailadmin_workflows_add_task;
    wagtailadmin_workflows_select_task_type: wagtailadmin_workflows_select_task_type;
    wagtailadmin_workflows_task_index: wagtailadmin_workflows_task_index;
    wagtailadmin_workflows_task_index_results: wagtailadmin_workflows_task_index_results;
    wagtailadmin_workflows_edit_task: wagtailadmin_workflows_edit_task;
    wagtailadmin_workflows_disable_task: wagtailadmin_workflows_disable_task;
    wagtailadmin_workflows_enable_task: wagtailadmin_workflows_enable_task;
    wagtailadmin_workflows_task_chooser: wagtailadmin_workflows_task_chooser;
    wagtailadmin_workflows_task_chooser_results: wagtailadmin_workflows_task_chooser_results;
    wagtailadmin_workflows_task_chooser_create: wagtailadmin_workflows_task_chooser_create;
    wagtailadmin_workflows_task_chosen: wagtailadmin_workflows_task_chosen;
    wagtailadmin_reports_locked_pages: wagtailadmin_reports_locked_pages;
    wagtailadmin_reports_locked_pages_results: wagtailadmin_reports_locked_pages_results;
    wagtailadmin_reports_workflow: wagtailadmin_reports_workflow;
    wagtailadmin_reports_workflow_results: wagtailadmin_reports_workflow_results;
    wagtailadmin_reports_workflow_tasks: wagtailadmin_reports_workflow_tasks;
    wagtailadmin_reports_workflow_tasks_results: wagtailadmin_reports_workflow_tasks_results;
    wagtailadmin_reports_site_history: wagtailadmin_reports_site_history;
    wagtailadmin_reports_site_history_results: wagtailadmin_reports_site_history_results;
    wagtailadmin_reports_aging_pages: wagtailadmin_reports_aging_pages;
    wagtailadmin_reports_aging_pages_results: wagtailadmin_reports_aging_pages_results;
    wagtailadmin_reports_page_types_usage: wagtailadmin_reports_page_types_usage;
    wagtailadmin_reports_page_types_usage_results: wagtailadmin_reports_page_types_usage_results;
    wagtailadmin_account: wagtailadmin_account;
    wagtailadmin_logout: wagtailadmin_logout;
    wagtailadmin_dismissibles: wagtailadmin_dismissibles;
    wagtailadmin_editing_sessions_ping: wagtailadmin_editing_sessions_ping;
    wagtailadmin_editing_sessions_release: wagtailadmin_editing_sessions_release;
    wagtailadmin_block_preview: wagtailadmin_block_preview;
    wagtailforms_index: wagtailforms_index;
    wagtailforms_index_results: wagtailforms_index_results;
    wagtailforms_list_submissions: wagtailforms_list_submissions;
    wagtailforms_list_submissions_results: wagtailforms_list_submissions_results;
    wagtailforms_delete_submissions: wagtailforms_delete_submissions;
    wagtailredirects_index: wagtailredirects_index;
    wagtailredirects_index_results: wagtailredirects_index_results;
    wagtailredirects_add: wagtailredirects_add;
    wagtailredirects_edit: wagtailredirects_edit;
    wagtailredirects_delete: wagtailredirects_delete;
    wagtailredirects_start_import: wagtailredirects_start_import;
    wagtailredirects_process_import: wagtailredirects_process_import;
    wagtailsettings_edit: wagtailsettings_edit;
    wagtailstyleguide: wagtailstyleguide;
    wagtailembeds_chooser: wagtailembeds_chooser;
    wagtailembeds_chooser_upload: wagtailembeds_chooser_upload;
    wagtailsnippets_index: wagtailsnippets_index;
    wagtaildocs_index: wagtaildocs_index;
    wagtaildocs_index_results: wagtaildocs_index_results;
    wagtaildocs_add: wagtaildocs_add;
    wagtaildocs_edit: wagtaildocs_edit;
    wagtaildocs_delete: wagtaildocs_delete;
    wagtaildocs_add_multiple: wagtaildocs_add_multiple;
    wagtaildocs_edit_multiple: wagtaildocs_edit_multiple;
    wagtaildocs_create_multiple_from_uploaded_document: wagtaildocs_create_multiple_from_uploaded_document;
    wagtaildocs_delete_multiple: wagtaildocs_delete_multiple;
    wagtaildocs_delete_upload_multiple: wagtaildocs_delete_upload_multiple;
    wagtaildocs_document_usage: wagtaildocs_document_usage;
    wagtailimages_index: wagtailimages_index;
    wagtailimages_index_results: wagtailimages_index_results;
    wagtailimages_edit: wagtailimages_edit;
    wagtailimages_delete: wagtailimages_delete;
    wagtailimages_url_generator: wagtailimages_url_generator;
    wagtailimages_generate_url: wagtailimages_generate_url;
    wagtailimages_preview: wagtailimages_preview;
    wagtailimages_add: wagtailimages_add;
    wagtailimages_image_usage: wagtailimages_image_usage;
    wagtailimages_add_multiple: wagtailimages_add_multiple;
    wagtailimages_edit_multiple: wagtailimages_edit_multiple;
    wagtailimages_create_multiple_from_uploaded_image: wagtailimages_create_multiple_from_uploaded_image;
    wagtailimages_delete_multiple: wagtailimages_delete_multiple;
    wagtailimages_delete_upload_multiple: wagtailimages_delete_upload_multiple;
    wagtailsnippets_thelabui_labuitoolboxsnippet_list: wagtailsnippets_thelabui_labuitoolboxsnippet_list;
    wagtailsnippets_thelabui_labuitoolboxsnippet_list_results: wagtailsnippets_thelabui_labuitoolboxsnippet_list_results;
    wagtailsnippets_thelabui_labuitoolboxsnippet_add: wagtailsnippets_thelabui_labuitoolboxsnippet_add;
    wagtailsnippets_thelabui_labuitoolboxsnippet_edit: wagtailsnippets_thelabui_labuitoolboxsnippet_edit;
    wagtailsnippets_thelabui_labuitoolboxsnippet_delete: wagtailsnippets_thelabui_labuitoolboxsnippet_delete;
    wagtailsnippets_thelabui_labuitoolboxsnippet_usage: wagtailsnippets_thelabui_labuitoolboxsnippet_usage;
    wagtailsnippets_thelabui_labuitoolboxsnippet_history: wagtailsnippets_thelabui_labuitoolboxsnippet_history;
    wagtailsnippets_thelabui_labuitoolboxsnippet_history_results: wagtailsnippets_thelabui_labuitoolboxsnippet_history_results;
    wagtailsnippets_thelabui_labuitoolboxsnippet_copy: wagtailsnippets_thelabui_labuitoolboxsnippet_copy;
    wagtailsnippets_thelabui_labuitoolboxsnippet_preview_on_add: wagtailsnippets_thelabui_labuitoolboxsnippet_preview_on_add;
    wagtailsnippets_thelabui_labuitoolboxsnippet_preview_on_edit: wagtailsnippets_thelabui_labuitoolboxsnippet_preview_on_edit;
    wagtailsnippets_thelabui_labuitoolboxsnippet_revisions_view: wagtailsnippets_thelabui_labuitoolboxsnippet_revisions_view;
    wagtailsnippets_thelabui_labuitoolboxsnippet_revisions_revert: wagtailsnippets_thelabui_labuitoolboxsnippet_revisions_revert;
    wagtailsnippets_thelabui_labuitoolboxsnippet_revisions_unschedule: wagtailsnippets_thelabui_labuitoolboxsnippet_revisions_unschedule;
    wagtailsnippets_thelabui_labuitoolboxsnippet_unpublish: wagtailsnippets_thelabui_labuitoolboxsnippet_unpublish;
    wagtailsnippets_thelabui_labuitoolboxsnippet_lock: wagtailsnippets_thelabui_labuitoolboxsnippet_lock;
    wagtailsnippets_thelabui_labuitoolboxsnippet_unlock: wagtailsnippets_thelabui_labuitoolboxsnippet_unlock;
    wagtailsnippetchoosers_thelabui_labuitoolboxsnippet_choose: wagtailsnippetchoosers_thelabui_labuitoolboxsnippet_choose;
    wagtailsnippetchoosers_thelabui_labuitoolboxsnippet_choose_results: wagtailsnippetchoosers_thelabui_labuitoolboxsnippet_choose_results;
    wagtailsnippetchoosers_thelabui_labuitoolboxsnippet_chosen: wagtailsnippetchoosers_thelabui_labuitoolboxsnippet_chosen;
    wagtailsnippetchoosers_thelabui_labuitoolboxsnippet_chosen_multiple: wagtailsnippetchoosers_thelabui_labuitoolboxsnippet_chosen_multiple;
    wagtailsnippetchoosers_thelabui_labuitoolboxsnippet_create: wagtailsnippetchoosers_thelabui_labuitoolboxsnippet_create;
    wagtailsnippets_locations_country_list: wagtailsnippets_locations_country_list;
    wagtailsnippets_locations_country_list_results: wagtailsnippets_locations_country_list_results;
    wagtailsnippets_locations_country_add: wagtailsnippets_locations_country_add;
    wagtailsnippets_locations_country_edit: wagtailsnippets_locations_country_edit;
    wagtailsnippets_locations_country_delete: wagtailsnippets_locations_country_delete;
    wagtailsnippets_locations_country_usage: wagtailsnippets_locations_country_usage;
    wagtailsnippets_locations_country_history: wagtailsnippets_locations_country_history;
    wagtailsnippets_locations_country_history_results: wagtailsnippets_locations_country_history_results;
    wagtailsnippets_locations_country_copy: wagtailsnippets_locations_country_copy;
    wagtailsnippetchoosers_locations_country_choose: wagtailsnippetchoosers_locations_country_choose;
    wagtailsnippetchoosers_locations_country_choose_results: wagtailsnippetchoosers_locations_country_choose_results;
    wagtailsnippetchoosers_locations_country_chosen: wagtailsnippetchoosers_locations_country_chosen;
    wagtailsnippetchoosers_locations_country_chosen_multiple: wagtailsnippetchoosers_locations_country_chosen_multiple;
    wagtailsnippetchoosers_locations_country_create: wagtailsnippetchoosers_locations_country_create;
    wagtailsnippets_cms_tierednav_list: wagtailsnippets_cms_tierednav_list;
    wagtailsnippets_cms_tierednav_list_results: wagtailsnippets_cms_tierednav_list_results;
    wagtailsnippets_cms_tierednav_add: wagtailsnippets_cms_tierednav_add;
    wagtailsnippets_cms_tierednav_edit: wagtailsnippets_cms_tierednav_edit;
    wagtailsnippets_cms_tierednav_delete: wagtailsnippets_cms_tierednav_delete;
    wagtailsnippets_cms_tierednav_usage: wagtailsnippets_cms_tierednav_usage;
    wagtailsnippets_cms_tierednav_history: wagtailsnippets_cms_tierednav_history;
    wagtailsnippets_cms_tierednav_history_results: wagtailsnippets_cms_tierednav_history_results;
    wagtailsnippets_cms_tierednav_copy: wagtailsnippets_cms_tierednav_copy;
    wagtailsnippetchoosers_cms_tierednav_choose: wagtailsnippetchoosers_cms_tierednav_choose;
    wagtailsnippetchoosers_cms_tierednav_choose_results: wagtailsnippetchoosers_cms_tierednav_choose_results;
    wagtailsnippetchoosers_cms_tierednav_chosen: wagtailsnippetchoosers_cms_tierednav_chosen;
    wagtailsnippetchoosers_cms_tierednav_chosen_multiple: wagtailsnippetchoosers_cms_tierednav_chosen_multiple;
    wagtailsnippetchoosers_cms_tierednav_create: wagtailsnippetchoosers_cms_tierednav_create;
    wagtailsites_index: wagtailsites_index;
    wagtailsites_index_results: wagtailsites_index_results;
    wagtailsites_add: wagtailsites_add;
    wagtailsites_edit: wagtailsites_edit;
    wagtailsites_delete: wagtailsites_delete;
    wagtailsites_history: wagtailsites_history;
    wagtailsites_history_results: wagtailsites_history_results;
    wagtailsites_usage: wagtailsites_usage;
    wagtailsites_copy: wagtailsites_copy;
    wagtailusers_users_index: wagtailusers_users_index;
    wagtailusers_users_index_results: wagtailusers_users_index_results;
    wagtailusers_users_add: wagtailusers_users_add;
    wagtailusers_users_edit: wagtailusers_users_edit;
    wagtailusers_users_delete: wagtailusers_users_delete;
    wagtailusers_users_history: wagtailusers_users_history;
    wagtailusers_users_history_results: wagtailusers_users_history_results;
    wagtailusers_users_usage: wagtailusers_users_usage;
    wagtailusers_users_copy: wagtailusers_users_copy;
    wagtailusers_groups_index: wagtailusers_groups_index;
    wagtailusers_groups_index_results: wagtailusers_groups_index_results;
    wagtailusers_groups_add: wagtailusers_groups_add;
    wagtailusers_groups_edit: wagtailusers_groups_edit;
    wagtailusers_groups_delete: wagtailusers_groups_delete;
    wagtailusers_groups_history: wagtailusers_groups_history;
    wagtailusers_groups_history_results: wagtailusers_groups_history_results;
    wagtailusers_groups_usage: wagtailusers_groups_usage;
    wagtaildocs_chooser_choose: wagtaildocs_chooser_choose;
    wagtaildocs_chooser_choose_results: wagtaildocs_chooser_choose_results;
    wagtaildocs_chooser_chosen: wagtaildocs_chooser_chosen;
    wagtaildocs_chooser_chosen_multiple: wagtaildocs_chooser_chosen_multiple;
    wagtaildocs_chooser_create: wagtaildocs_chooser_create;
    wagtailimages_chooser_choose: wagtailimages_chooser_choose;
    wagtailimages_chooser_choose_results: wagtailimages_chooser_choose_results;
    wagtailimages_chooser_chosen: wagtailimages_chooser_chosen;
    wagtailimages_chooser_chosen_multiple: wagtailimages_chooser_chosen_multiple;
    wagtailimages_chooser_create: wagtailimages_chooser_create;
    wagtailimages_chooser_select_format: wagtailimages_chooser_select_format;
    wagtailvideos_chooser_choose: wagtailvideos_chooser_choose;
    wagtailvideos_chooser_choose_results: wagtailvideos_chooser_choose_results;
    wagtailvideos_chooser_chosen: wagtailvideos_chooser_chosen;
    wagtailvideos_chooser_chosen_multiple: wagtailvideos_chooser_chosen_multiple;
    wagtailvideos_chooser_create: wagtailvideos_chooser_create;
    wagtailvideos_add: wagtailvideos_add;
    wagtailvideos_add_multiple: wagtailvideos_add_multiple;
    wagtailvideos_edit_multiple: wagtailvideos_edit_multiple;
    wagtailvideos_create_multiple_from_uploaded_image: wagtailvideos_create_multiple_from_uploaded_image;
    wagtailvideos_delete_multiple: wagtailvideos_delete_multiple;
    wagtailvideos_delete_upload_multiple: wagtailvideos_delete_upload_multiple;
    wagtailvideos_index: wagtailvideos_index;
    wagtailvideos_index_results: wagtailvideos_index_results;
    wagtail_modeladmin_javascript_catalog: wagtail_modeladmin_javascript_catalog;
    wagtailadmin_sprite: wagtailadmin_sprite;
    wagtailadmin_login: wagtailadmin_login;
    wagtailadmin_password_reset: wagtailadmin_password_reset;
    wagtailadmin_password_reset_done: wagtailadmin_password_reset_done;
    wagtailadmin_password_reset_confirm: wagtailadmin_password_reset_confirm;
    wagtailadmin_password_reset_complete: wagtailadmin_password_reset_complete;
    wagtailadmin_javascript_catalog: wagtailadmin_javascript_catalog;
    health_check_health_check_home: health_check_health_check_home;
    health_check_health_check_subset: health_check_health_check_subset;
    locations_api_locationlist: locations_api_locationlist;
    locations_api_locationdetail: locations_api_locationdetail;
    locations_api_waitlistdetail: locations_api_waitlistdetail;
    locations_api_flush: locations_api_flush;
    locations_api_waitlist_join: locations_api_waitlist_join;
    locations_api_waitlist_getestimate: locations_api_waitlist_getestimate;
    locations_api_waitlist_entry: locations_api_waitlist_entry;
    locations_api_locationlist_alt: locations_api_locationlist_alt;
    locations_api_locationdetail_alt: locations_api_locationdetail_alt;
    locations_api_waitlistdetail_alt: locations_api_waitlistdetail_alt;
    locations_api_flush_alt: locations_api_flush_alt;
    locations_api_waitlist_join_alt: locations_api_waitlist_join_alt;
    locations_api_waitlist_getestimate_alt: locations_api_waitlist_getestimate_alt;
    locations_api_waitlist_entry_alt: locations_api_waitlist_entry_alt;
    locations_locationredirect: locations_locationredirect;
    api_fcc_unsubscribe: api_fcc_unsubscribe;
    site_footer: site_footer;
    videotrack_serve: videotrack_serve;
    error_404: error_404;
    integration_manifest: integration_manifest;
    google_verification: google_verification;
    wagtailcore_authenticate_with_password: wagtailcore_authenticate_with_password;
    wagtailcore_login: wagtailcore_login;
    __reactivated_do_not_use: __reactivated_do_not_use;
    __reactivated_do_not_use_args: __reactivated_do_not_use_args;
}

interface sitemap {
    name: 'sitemap';
    args: sitemap_args;
}

interface sitemap_args {
}

interface sitemap_index {
    name: 'sitemap-index';
    args: sitemap_index_args;
}

interface sitemap_index_args {
}

interface thelabui_load_balancer_health_check {
    name: 'thelabui:load-balancer-health-check';
    args: thelabui_load_balancer_health_check_args;
}

interface thelabui_load_balancer_health_check_args {
}

interface thelabui_csrftoken_get {
    name: 'thelabui:csrftoken-get';
    args: thelabui_csrftoken_get_args;
}

interface thelabui_csrftoken_get_args {
}

interface thelabui_robots_txt {
    name: 'thelabui:robots-txt';
    args: thelabui_robots_txt_args;
}

interface thelabui_robots_txt_args {
}

interface thelabui_security_txt {
    name: 'thelabui:security-txt';
    args: thelabui_security_txt_args;
}

interface thelabui_security_txt_args {
}

interface thelabui_sitemap {
    name: 'thelabui:sitemap';
    args: thelabui_sitemap_args;
}

interface thelabui_sitemap_args {
}

interface wagtailadmin_home {
    name: 'wagtailadmin_home';
    args: wagtailadmin_home_args;
}

interface wagtailadmin_home_args {
}

interface wagtailadmin_api_pages_listing {
    name: 'wagtailadmin_api:pages:listing';
    args: wagtailadmin_api_pages_listing_args;
}

interface wagtailadmin_api_pages_listing_args {
}

interface wagtailadmin_api_pages_detail {
    name: 'wagtailadmin_api:pages:detail';
    args: wagtailadmin_api_pages_detail_args;
}

interface wagtailadmin_api_pages_detail_args {
    pk: number;
}

interface wagtailadmin_api_pages_find {
    name: 'wagtailadmin_api:pages:find';
    args: wagtailadmin_api_pages_find_args;
}

interface wagtailadmin_api_pages_find_args {
}

interface wagtailadmin_api_pages_action {
    name: 'wagtailadmin_api:pages:action';
    args: wagtailadmin_api_pages_action_args;
}

interface wagtailadmin_api_pages_action_args {
    pk: number;
    action_name: string;
}

interface wagtailadmin_api_documents_listing {
    name: 'wagtailadmin_api:documents:listing';
    args: wagtailadmin_api_documents_listing_args;
}

interface wagtailadmin_api_documents_listing_args {
}

interface wagtailadmin_api_documents_detail {
    name: 'wagtailadmin_api:documents:detail';
    args: wagtailadmin_api_documents_detail_args;
}

interface wagtailadmin_api_documents_detail_args {
    pk: number;
}

interface wagtailadmin_api_documents_find {
    name: 'wagtailadmin_api:documents:find';
    args: wagtailadmin_api_documents_find_args;
}

interface wagtailadmin_api_documents_find_args {
}

interface wagtailadmin_api_images_listing {
    name: 'wagtailadmin_api:images:listing';
    args: wagtailadmin_api_images_listing_args;
}

interface wagtailadmin_api_images_listing_args {
}

interface wagtailadmin_api_images_detail {
    name: 'wagtailadmin_api:images:detail';
    args: wagtailadmin_api_images_detail_args;
}

interface wagtailadmin_api_images_detail_args {
    pk: number;
}

interface wagtailadmin_api_images_find {
    name: 'wagtailadmin_api:images:find';
    args: wagtailadmin_api_images_find_args;
}

interface wagtailadmin_api_images_find_args {
}

interface wagtailadmin_error_test {
    name: 'wagtailadmin_error_test';
    args: wagtailadmin_error_test_args;
}

interface wagtailadmin_error_test_args {
}

interface wagtailadmin_explore_root {
    name: 'wagtailadmin_explore_root';
    args: wagtailadmin_explore_root_args;
}

interface wagtailadmin_explore_root_args {
}

interface wagtailadmin_explore {
    name: 'wagtailadmin_explore';
    args: wagtailadmin_explore_args;
}

interface wagtailadmin_explore_args {
    parent_page_id: number;
}

interface wagtailadmin_explore_results {
    name: 'wagtailadmin_explore_results';
    args: wagtailadmin_explore_results_args;
}

interface wagtailadmin_explore_results_args {
    parent_page_id: number;
}

interface wagtail_bulk_action {
    name: 'wagtail_bulk_action';
    args: wagtail_bulk_action_args;
}

interface wagtail_bulk_action_args {
    app_label: string;
    model_name: string;
    action: string;
}

interface wagtailadmin_pages_add {
    name: 'wagtailadmin_pages:add';
    args: wagtailadmin_pages_add_args;
}

interface wagtailadmin_pages_add_args {
    content_type_app_name: string;
    content_type_model_name: string;
    parent_page_id: number;
}

interface wagtailadmin_pages_preview_on_add {
    name: 'wagtailadmin_pages:preview_on_add';
    args: wagtailadmin_pages_preview_on_add_args;
}

interface wagtailadmin_pages_preview_on_add_args {
    content_type_app_name: string;
    content_type_model_name: string;
    parent_page_id: number;
}

interface wagtailadmin_pages_type_use {
    name: 'wagtailadmin_pages:type_use';
    args: wagtailadmin_pages_type_use_args;
}

interface wagtailadmin_pages_type_use_args {
    content_type_app_name: string;
    content_type_model_name: string;
}

interface wagtailadmin_pages_type_use_results {
    name: 'wagtailadmin_pages:type_use_results';
    args: wagtailadmin_pages_type_use_results_args;
}

interface wagtailadmin_pages_type_use_results_args {
    content_type_app_name: string;
    content_type_model_name: string;
}

interface wagtailadmin_pages_usage {
    name: 'wagtailadmin_pages:usage';
    args: wagtailadmin_pages_usage_args;
}

interface wagtailadmin_pages_usage_args {
    page_id: number;
}

interface wagtailadmin_pages_edit {
    name: 'wagtailadmin_pages:edit';
    args: wagtailadmin_pages_edit_args;
}

interface wagtailadmin_pages_edit_args {
    page_id: number;
}

interface wagtailadmin_pages_preview_on_edit {
    name: 'wagtailadmin_pages:preview_on_edit';
    args: wagtailadmin_pages_preview_on_edit_args;
}

interface wagtailadmin_pages_preview_on_edit_args {
    page_id: number;
}

interface wagtailadmin_pages_view_draft {
    name: 'wagtailadmin_pages:view_draft';
    args: wagtailadmin_pages_view_draft_args;
}

interface wagtailadmin_pages_view_draft_args {
    page_id: number;
}

interface wagtailadmin_pages_add_subpage {
    name: 'wagtailadmin_pages:add_subpage';
    args: wagtailadmin_pages_add_subpage_args;
}

interface wagtailadmin_pages_add_subpage_args {
    parent_page_id: number;
}

interface wagtailadmin_pages_delete {
    name: 'wagtailadmin_pages:delete';
    args: wagtailadmin_pages_delete_args;
}

interface wagtailadmin_pages_delete_args {
    page_id: number;
}

interface wagtailadmin_pages_unpublish {
    name: 'wagtailadmin_pages:unpublish';
    args: wagtailadmin_pages_unpublish_args;
}

interface wagtailadmin_pages_unpublish_args {
    page_id: number;
}

interface wagtailadmin_pages_convert_alias {
    name: 'wagtailadmin_pages:convert_alias';
    args: wagtailadmin_pages_convert_alias_args;
}

interface wagtailadmin_pages_convert_alias_args {
    page_id: number;
}

interface wagtailadmin_pages_search {
    name: 'wagtailadmin_pages:search';
    args: wagtailadmin_pages_search_args;
}

interface wagtailadmin_pages_search_args {
}

interface wagtailadmin_pages_search_results {
    name: 'wagtailadmin_pages:search_results';
    args: wagtailadmin_pages_search_results_args;
}

interface wagtailadmin_pages_search_results_args {
}

interface wagtailadmin_pages_move {
    name: 'wagtailadmin_pages:move';
    args: wagtailadmin_pages_move_args;
}

interface wagtailadmin_pages_move_args {
    page_to_move_id: number;
}

interface wagtailadmin_pages_move_confirm {
    name: 'wagtailadmin_pages:move_confirm';
    args: wagtailadmin_pages_move_confirm_args;
}

interface wagtailadmin_pages_move_confirm_args {
    page_to_move_id: number;
    destination_id: number;
}

interface wagtailadmin_pages_set_page_position {
    name: 'wagtailadmin_pages:set_page_position';
    args: wagtailadmin_pages_set_page_position_args;
}

interface wagtailadmin_pages_set_page_position_args {
    page_to_move_id: number;
}

interface wagtailadmin_pages_copy {
    name: 'wagtailadmin_pages:copy';
    args: wagtailadmin_pages_copy_args;
}

interface wagtailadmin_pages_copy_args {
    page_id: number;
}

interface wagtailadmin_pages_workflow_action {
    name: 'wagtailadmin_pages:workflow_action';
    args: wagtailadmin_pages_workflow_action_args;
}

interface wagtailadmin_pages_workflow_action_args {
    page_id: number;
    action_name: string;
    task_state_id: number;
}

interface wagtailadmin_pages_collect_workflow_action_data {
    name: 'wagtailadmin_pages:collect_workflow_action_data';
    args: wagtailadmin_pages_collect_workflow_action_data_args;
}

interface wagtailadmin_pages_collect_workflow_action_data_args {
    page_id: number;
    action_name: string;
    task_state_id: number;
}

interface wagtailadmin_pages_confirm_workflow_cancellation {
    name: 'wagtailadmin_pages:confirm_workflow_cancellation';
    args: wagtailadmin_pages_confirm_workflow_cancellation_args;
}

interface wagtailadmin_pages_confirm_workflow_cancellation_args {
    page_id: number;
}

interface wagtailadmin_pages_workflow_preview {
    name: 'wagtailadmin_pages:workflow_preview';
    args: wagtailadmin_pages_workflow_preview_args;
}

interface wagtailadmin_pages_workflow_preview_args {
    page_id: number;
    task_id: number;
}

interface wagtailadmin_pages_set_privacy {
    name: 'wagtailadmin_pages:set_privacy';
    args: wagtailadmin_pages_set_privacy_args;
}

interface wagtailadmin_pages_set_privacy_args {
    page_id: number;
}

interface wagtailadmin_pages_lock {
    name: 'wagtailadmin_pages:lock';
    args: wagtailadmin_pages_lock_args;
}

interface wagtailadmin_pages_lock_args {
    page_id: number;
}

interface wagtailadmin_pages_unlock {
    name: 'wagtailadmin_pages:unlock';
    args: wagtailadmin_pages_unlock_args;
}

interface wagtailadmin_pages_unlock_args {
    page_id: number;
}

interface wagtailadmin_pages_revisions_index {
    name: 'wagtailadmin_pages:revisions_index';
    args: wagtailadmin_pages_revisions_index_args;
}

interface wagtailadmin_pages_revisions_index_args {
    page_id: number;
}

interface wagtailadmin_pages_revisions_view {
    name: 'wagtailadmin_pages:revisions_view';
    args: wagtailadmin_pages_revisions_view_args;
}

interface wagtailadmin_pages_revisions_view_args {
    page_id: number;
    revision_id: number;
}

interface wagtailadmin_pages_revisions_revert {
    name: 'wagtailadmin_pages:revisions_revert';
    args: wagtailadmin_pages_revisions_revert_args;
}

interface wagtailadmin_pages_revisions_revert_args {
    page_id: number;
    revision_id: number;
}

interface wagtailadmin_pages_revisions_unschedule {
    name: 'wagtailadmin_pages:revisions_unschedule';
    args: wagtailadmin_pages_revisions_unschedule_args;
}

interface wagtailadmin_pages_revisions_unschedule_args {
    page_id: number;
    revision_id: number;
}

interface wagtailadmin_pages_workflow_history {
    name: 'wagtailadmin_pages:workflow_history';
    args: wagtailadmin_pages_workflow_history_args;
}

interface wagtailadmin_pages_workflow_history_args {
    page_id: number;
}

interface wagtailadmin_pages_workflow_history_detail {
    name: 'wagtailadmin_pages:workflow_history_detail';
    args: wagtailadmin_pages_workflow_history_detail_args;
}

interface wagtailadmin_pages_workflow_history_detail_args {
    page_id: number;
    workflow_state_id: number;
}

interface wagtailadmin_pages_history {
    name: 'wagtailadmin_pages:history';
    args: wagtailadmin_pages_history_args;
}

interface wagtailadmin_pages_history_args {
    page_id: number;
}

interface wagtailadmin_pages_history_results {
    name: 'wagtailadmin_pages:history_results';
    args: wagtailadmin_pages_history_results_args;
}

interface wagtailadmin_pages_history_results_args {
    page_id: number;
}

interface wagtailadmin_choose_page {
    name: 'wagtailadmin_choose_page';
    args: wagtailadmin_choose_page_args;
}

interface wagtailadmin_choose_page_args {
}

interface wagtailadmin_choose_page_child {
    name: 'wagtailadmin_choose_page_child';
    args: wagtailadmin_choose_page_child_args;
}

interface wagtailadmin_choose_page_child_args {
    parent_page_id: number;
}

interface wagtailadmin_choose_page_search {
    name: 'wagtailadmin_choose_page_search';
    args: wagtailadmin_choose_page_search_args;
}

interface wagtailadmin_choose_page_search_args {
}

interface wagtailadmin_choose_page_chosen_multiple {
    name: 'wagtailadmin_choose_page_chosen_multiple';
    args: wagtailadmin_choose_page_chosen_multiple_args;
}

interface wagtailadmin_choose_page_chosen_multiple_args {
}

interface wagtailadmin_choose_page_external_link {
    name: 'wagtailadmin_choose_page_external_link';
    args: wagtailadmin_choose_page_external_link_args;
}

interface wagtailadmin_choose_page_external_link_args {
}

interface wagtailadmin_choose_page_email_link {
    name: 'wagtailadmin_choose_page_email_link';
    args: wagtailadmin_choose_page_email_link_args;
}

interface wagtailadmin_choose_page_email_link_args {
}

interface wagtailadmin_choose_page_phone_link {
    name: 'wagtailadmin_choose_page_phone_link';
    args: wagtailadmin_choose_page_phone_link_args;
}

interface wagtailadmin_choose_page_phone_link_args {
}

interface wagtailadmin_choose_page_anchor_link {
    name: 'wagtailadmin_choose_page_anchor_link';
    args: wagtailadmin_choose_page_anchor_link_args;
}

interface wagtailadmin_choose_page_anchor_link_args {
}

interface wagtailadmin_tag_autocomplete {
    name: 'wagtailadmin_tag_autocomplete';
    args: wagtailadmin_tag_autocomplete_args;
}

interface wagtailadmin_tag_autocomplete_args {
}

interface wagtailadmin_tag_model_autocomplete {
    name: 'wagtailadmin_tag_model_autocomplete';
    args: wagtailadmin_tag_model_autocomplete_args;
}

interface wagtailadmin_tag_model_autocomplete_args {
    app_name: string;
    model_name: string;
}

interface wagtailadmin_collections_index {
    name: 'wagtailadmin_collections:index';
    args: wagtailadmin_collections_index_args;
}

interface wagtailadmin_collections_index_args {
}

interface wagtailadmin_collections_add {
    name: 'wagtailadmin_collections:add';
    args: wagtailadmin_collections_add_args;
}

interface wagtailadmin_collections_add_args {
}

interface wagtailadmin_collections_edit {
    name: 'wagtailadmin_collections:edit';
    args: wagtailadmin_collections_edit_args;
}

interface wagtailadmin_collections_edit_args {
    pk: number;
}

interface wagtailadmin_collections_delete {
    name: 'wagtailadmin_collections:delete';
    args: wagtailadmin_collections_delete_args;
}

interface wagtailadmin_collections_delete_args {
    pk: number;
}

interface wagtailadmin_collections_set_privacy {
    name: 'wagtailadmin_collections:set_privacy';
    args: wagtailadmin_collections_set_privacy_args;
}

interface wagtailadmin_collections_set_privacy_args {
    collection_id: number;
}

interface wagtailadmin_workflows_index {
    name: 'wagtailadmin_workflows:index';
    args: wagtailadmin_workflows_index_args;
}

interface wagtailadmin_workflows_index_args {
}

interface wagtailadmin_workflows_index_results {
    name: 'wagtailadmin_workflows:index_results';
    args: wagtailadmin_workflows_index_results_args;
}

interface wagtailadmin_workflows_index_results_args {
}

interface wagtailadmin_workflows_add {
    name: 'wagtailadmin_workflows:add';
    args: wagtailadmin_workflows_add_args;
}

interface wagtailadmin_workflows_add_args {
}

interface wagtailadmin_workflows_enable {
    name: 'wagtailadmin_workflows:enable';
    args: wagtailadmin_workflows_enable_args;
}

interface wagtailadmin_workflows_enable_args {
    pk: number;
}

interface wagtailadmin_workflows_disable {
    name: 'wagtailadmin_workflows:disable';
    args: wagtailadmin_workflows_disable_args;
}

interface wagtailadmin_workflows_disable_args {
    pk: number;
}

interface wagtailadmin_workflows_edit {
    name: 'wagtailadmin_workflows:edit';
    args: wagtailadmin_workflows_edit_args;
}

interface wagtailadmin_workflows_edit_args {
    pk: number;
}

interface wagtailadmin_workflows_usage {
    name: 'wagtailadmin_workflows:usage';
    args: wagtailadmin_workflows_usage_args;
}

interface wagtailadmin_workflows_usage_args {
    pk: number;
}

interface wagtailadmin_workflows_usage_results {
    name: 'wagtailadmin_workflows:usage_results';
    args: wagtailadmin_workflows_usage_results_args;
}

interface wagtailadmin_workflows_usage_results_args {
    pk: number;
}

interface wagtailadmin_workflows_remove {
    name: 'wagtailadmin_workflows:remove';
    args: wagtailadmin_workflows_remove_args;
}

interface wagtailadmin_workflows_remove_args {
    page_pk: number;
    workflow_pk: number;
}

interface wagtailadmin_workflows_add_task {
    name: 'wagtailadmin_workflows:add_task';
    args: wagtailadmin_workflows_add_task_args;
}

interface wagtailadmin_workflows_add_task_args {
    app_label: string;
    model_name: string;
}

interface wagtailadmin_workflows_select_task_type {
    name: 'wagtailadmin_workflows:select_task_type';
    args: wagtailadmin_workflows_select_task_type_args;
}

interface wagtailadmin_workflows_select_task_type_args {
}

interface wagtailadmin_workflows_task_index {
    name: 'wagtailadmin_workflows:task_index';
    args: wagtailadmin_workflows_task_index_args;
}

interface wagtailadmin_workflows_task_index_args {
}

interface wagtailadmin_workflows_task_index_results {
    name: 'wagtailadmin_workflows:task_index_results';
    args: wagtailadmin_workflows_task_index_results_args;
}

interface wagtailadmin_workflows_task_index_results_args {
}

interface wagtailadmin_workflows_edit_task {
    name: 'wagtailadmin_workflows:edit_task';
    args: wagtailadmin_workflows_edit_task_args;
}

interface wagtailadmin_workflows_edit_task_args {
    pk: number;
}

interface wagtailadmin_workflows_disable_task {
    name: 'wagtailadmin_workflows:disable_task';
    args: wagtailadmin_workflows_disable_task_args;
}

interface wagtailadmin_workflows_disable_task_args {
    pk: number;
}

interface wagtailadmin_workflows_enable_task {
    name: 'wagtailadmin_workflows:enable_task';
    args: wagtailadmin_workflows_enable_task_args;
}

interface wagtailadmin_workflows_enable_task_args {
    pk: number;
}

interface wagtailadmin_workflows_task_chooser {
    name: 'wagtailadmin_workflows:task_chooser';
    args: wagtailadmin_workflows_task_chooser_args;
}

interface wagtailadmin_workflows_task_chooser_args {
}

interface wagtailadmin_workflows_task_chooser_results {
    name: 'wagtailadmin_workflows:task_chooser_results';
    args: wagtailadmin_workflows_task_chooser_results_args;
}

interface wagtailadmin_workflows_task_chooser_results_args {
}

interface wagtailadmin_workflows_task_chooser_create {
    name: 'wagtailadmin_workflows:task_chooser_create';
    args: wagtailadmin_workflows_task_chooser_create_args;
}

interface wagtailadmin_workflows_task_chooser_create_args {
}

interface wagtailadmin_workflows_task_chosen {
    name: 'wagtailadmin_workflows:task_chosen';
    args: wagtailadmin_workflows_task_chosen_args;
}

interface wagtailadmin_workflows_task_chosen_args {
    task_id: number;
}

interface wagtailadmin_reports_locked_pages {
    name: 'wagtailadmin_reports:locked_pages';
    args: wagtailadmin_reports_locked_pages_args;
}

interface wagtailadmin_reports_locked_pages_args {
}

interface wagtailadmin_reports_locked_pages_results {
    name: 'wagtailadmin_reports:locked_pages_results';
    args: wagtailadmin_reports_locked_pages_results_args;
}

interface wagtailadmin_reports_locked_pages_results_args {
}

interface wagtailadmin_reports_workflow {
    name: 'wagtailadmin_reports:workflow';
    args: wagtailadmin_reports_workflow_args;
}

interface wagtailadmin_reports_workflow_args {
}

interface wagtailadmin_reports_workflow_results {
    name: 'wagtailadmin_reports:workflow_results';
    args: wagtailadmin_reports_workflow_results_args;
}

interface wagtailadmin_reports_workflow_results_args {
}

interface wagtailadmin_reports_workflow_tasks {
    name: 'wagtailadmin_reports:workflow_tasks';
    args: wagtailadmin_reports_workflow_tasks_args;
}

interface wagtailadmin_reports_workflow_tasks_args {
}

interface wagtailadmin_reports_workflow_tasks_results {
    name: 'wagtailadmin_reports:workflow_tasks_results';
    args: wagtailadmin_reports_workflow_tasks_results_args;
}

interface wagtailadmin_reports_workflow_tasks_results_args {
}

interface wagtailadmin_reports_site_history {
    name: 'wagtailadmin_reports:site_history';
    args: wagtailadmin_reports_site_history_args;
}

interface wagtailadmin_reports_site_history_args {
}

interface wagtailadmin_reports_site_history_results {
    name: 'wagtailadmin_reports:site_history_results';
    args: wagtailadmin_reports_site_history_results_args;
}

interface wagtailadmin_reports_site_history_results_args {
}

interface wagtailadmin_reports_aging_pages {
    name: 'wagtailadmin_reports:aging_pages';
    args: wagtailadmin_reports_aging_pages_args;
}

interface wagtailadmin_reports_aging_pages_args {
}

interface wagtailadmin_reports_aging_pages_results {
    name: 'wagtailadmin_reports:aging_pages_results';
    args: wagtailadmin_reports_aging_pages_results_args;
}

interface wagtailadmin_reports_aging_pages_results_args {
}

interface wagtailadmin_reports_page_types_usage {
    name: 'wagtailadmin_reports:page_types_usage';
    args: wagtailadmin_reports_page_types_usage_args;
}

interface wagtailadmin_reports_page_types_usage_args {
}

interface wagtailadmin_reports_page_types_usage_results {
    name: 'wagtailadmin_reports:page_types_usage_results';
    args: wagtailadmin_reports_page_types_usage_results_args;
}

interface wagtailadmin_reports_page_types_usage_results_args {
}

interface wagtailadmin_account {
    name: 'wagtailadmin_account';
    args: wagtailadmin_account_args;
}

interface wagtailadmin_account_args {
}

interface wagtailadmin_logout {
    name: 'wagtailadmin_logout';
    args: wagtailadmin_logout_args;
}

interface wagtailadmin_logout_args {
}

interface wagtailadmin_dismissibles {
    name: 'wagtailadmin_dismissibles';
    args: wagtailadmin_dismissibles_args;
}

interface wagtailadmin_dismissibles_args {
}

interface wagtailadmin_editing_sessions_ping {
    name: 'wagtailadmin_editing_sessions:ping';
    args: wagtailadmin_editing_sessions_ping_args;
}

interface wagtailadmin_editing_sessions_ping_args {
    app_label: string;
    model_name: string;
    object_id: string;
    session_id: number;
}

interface wagtailadmin_editing_sessions_release {
    name: 'wagtailadmin_editing_sessions:release';
    args: wagtailadmin_editing_sessions_release_args;
}

interface wagtailadmin_editing_sessions_release_args {
    session_id: number;
}

interface wagtailadmin_block_preview {
    name: 'wagtailadmin_block_preview';
    args: wagtailadmin_block_preview_args;
}

interface wagtailadmin_block_preview_args {
}

interface wagtailforms_index {
    name: 'wagtailforms:index';
    args: wagtailforms_index_args;
}

interface wagtailforms_index_args {
}

interface wagtailforms_index_results {
    name: 'wagtailforms:index_results';
    args: wagtailforms_index_results_args;
}

interface wagtailforms_index_results_args {
}

interface wagtailforms_list_submissions {
    name: 'wagtailforms:list_submissions';
    args: wagtailforms_list_submissions_args;
}

interface wagtailforms_list_submissions_args {
    page_id: number;
}

interface wagtailforms_list_submissions_results {
    name: 'wagtailforms:list_submissions_results';
    args: wagtailforms_list_submissions_results_args;
}

interface wagtailforms_list_submissions_results_args {
    page_id: number;
}

interface wagtailforms_delete_submissions {
    name: 'wagtailforms:delete_submissions';
    args: wagtailforms_delete_submissions_args;
}

interface wagtailforms_delete_submissions_args {
    page_id: number;
}

interface wagtailredirects_index {
    name: 'wagtailredirects:index';
    args: wagtailredirects_index_args;
}

interface wagtailredirects_index_args {
}

interface wagtailredirects_index_results {
    name: 'wagtailredirects:index_results';
    args: wagtailredirects_index_results_args;
}

interface wagtailredirects_index_results_args {
}

interface wagtailredirects_add {
    name: 'wagtailredirects:add';
    args: wagtailredirects_add_args;
}

interface wagtailredirects_add_args {
}

interface wagtailredirects_edit {
    name: 'wagtailredirects:edit';
    args: wagtailredirects_edit_args;
}

interface wagtailredirects_edit_args {
    redirect_id: number;
}

interface wagtailredirects_delete {
    name: 'wagtailredirects:delete';
    args: wagtailredirects_delete_args;
}

interface wagtailredirects_delete_args {
    redirect_id: number;
}

interface wagtailredirects_start_import {
    name: 'wagtailredirects:start_import';
    args: wagtailredirects_start_import_args;
}

interface wagtailredirects_start_import_args {
}

interface wagtailredirects_process_import {
    name: 'wagtailredirects:process_import';
    args: wagtailredirects_process_import_args;
}

interface wagtailredirects_process_import_args {
}

interface wagtailsettings_edit {
    name: 'wagtailsettings:edit';
    args: wagtailsettings_edit_args;
}

interface wagtailsettings_edit_args {
    app_name: string;
    model_name: string;
    pk: number;
}

interface wagtailstyleguide {
    name: 'wagtailstyleguide';
    args: wagtailstyleguide_args;
}

interface wagtailstyleguide_args {
}

interface wagtailembeds_chooser {
    name: 'wagtailembeds:chooser';
    args: wagtailembeds_chooser_args;
}

interface wagtailembeds_chooser_args {
}

interface wagtailembeds_chooser_upload {
    name: 'wagtailembeds:chooser_upload';
    args: wagtailembeds_chooser_upload_args;
}

interface wagtailembeds_chooser_upload_args {
}

interface wagtailsnippets_index {
    name: 'wagtailsnippets:index';
    args: wagtailsnippets_index_args;
}

interface wagtailsnippets_index_args {
}

interface wagtaildocs_index {
    name: 'wagtaildocs:index';
    args: wagtaildocs_index_args;
}

interface wagtaildocs_index_args {
}

interface wagtaildocs_index_results {
    name: 'wagtaildocs:index_results';
    args: wagtaildocs_index_results_args;
}

interface wagtaildocs_index_results_args {
}

interface wagtaildocs_add {
    name: 'wagtaildocs:add';
    args: wagtaildocs_add_args;
}

interface wagtaildocs_add_args {
}

interface wagtaildocs_edit {
    name: 'wagtaildocs:edit';
    args: wagtaildocs_edit_args;
}

interface wagtaildocs_edit_args {
    document_id: number;
}

interface wagtaildocs_delete {
    name: 'wagtaildocs:delete';
    args: wagtaildocs_delete_args;
}

interface wagtaildocs_delete_args {
    document_id: number;
}

interface wagtaildocs_add_multiple {
    name: 'wagtaildocs:add_multiple';
    args: wagtaildocs_add_multiple_args;
}

interface wagtaildocs_add_multiple_args {
}

interface wagtaildocs_edit_multiple {
    name: 'wagtaildocs:edit_multiple';
    args: wagtaildocs_edit_multiple_args;
}

interface wagtaildocs_edit_multiple_args {
    doc_id: number;
}

interface wagtaildocs_create_multiple_from_uploaded_document {
    name: 'wagtaildocs:create_multiple_from_uploaded_document';
    args: wagtaildocs_create_multiple_from_uploaded_document_args;
}

interface wagtaildocs_create_multiple_from_uploaded_document_args {
    uploaded_file_id: number;
}

interface wagtaildocs_delete_multiple {
    name: 'wagtaildocs:delete_multiple';
    args: wagtaildocs_delete_multiple_args;
}

interface wagtaildocs_delete_multiple_args {
    doc_id: number;
}

interface wagtaildocs_delete_upload_multiple {
    name: 'wagtaildocs:delete_upload_multiple';
    args: wagtaildocs_delete_upload_multiple_args;
}

interface wagtaildocs_delete_upload_multiple_args {
    uploaded_file_id: number;
}

interface wagtaildocs_document_usage {
    name: 'wagtaildocs:document_usage';
    args: wagtaildocs_document_usage_args;
}

interface wagtaildocs_document_usage_args {
    document_id: number;
}

interface wagtailimages_index {
    name: 'wagtailimages:index';
    args: wagtailimages_index_args;
}

interface wagtailimages_index_args {
}

interface wagtailimages_index_results {
    name: 'wagtailimages:index_results';
    args: wagtailimages_index_results_args;
}

interface wagtailimages_index_results_args {
}

interface wagtailimages_edit {
    name: 'wagtailimages:edit';
    args: wagtailimages_edit_args;
}

interface wagtailimages_edit_args {
    image_id: number;
}

interface wagtailimages_delete {
    name: 'wagtailimages:delete';
    args: wagtailimages_delete_args;
}

interface wagtailimages_delete_args {
    image_id: number;
}

interface wagtailimages_url_generator {
    name: 'wagtailimages:url_generator';
    args: wagtailimages_url_generator_args;
}

interface wagtailimages_url_generator_args {
    image_id: number;
}

interface wagtailimages_generate_url {
    name: 'wagtailimages:generate_url';
    args: wagtailimages_generate_url_args;
}

interface wagtailimages_generate_url_args {
    image_id: number;
    filter_spec: string;
}

interface wagtailimages_preview {
    name: 'wagtailimages:preview';
    args: wagtailimages_preview_args;
}

interface wagtailimages_preview_args {
    image_id: number;
    filter_spec: string;
}

interface wagtailimages_add {
    name: 'wagtailimages:add';
    args: wagtailimages_add_args;
}

interface wagtailimages_add_args {
}

interface wagtailimages_image_usage {
    name: 'wagtailimages:image_usage';
    args: wagtailimages_image_usage_args;
}

interface wagtailimages_image_usage_args {
    image_id: number;
}

interface wagtailimages_add_multiple {
    name: 'wagtailimages:add_multiple';
    args: wagtailimages_add_multiple_args;
}

interface wagtailimages_add_multiple_args {
}

interface wagtailimages_edit_multiple {
    name: 'wagtailimages:edit_multiple';
    args: wagtailimages_edit_multiple_args;
}

interface wagtailimages_edit_multiple_args {
    image_id: number;
}

interface wagtailimages_create_multiple_from_uploaded_image {
    name: 'wagtailimages:create_multiple_from_uploaded_image';
    args: wagtailimages_create_multiple_from_uploaded_image_args;
}

interface wagtailimages_create_multiple_from_uploaded_image_args {
    uploaded_file_id: number;
}

interface wagtailimages_delete_multiple {
    name: 'wagtailimages:delete_multiple';
    args: wagtailimages_delete_multiple_args;
}

interface wagtailimages_delete_multiple_args {
    image_id: number;
}

interface wagtailimages_delete_upload_multiple {
    name: 'wagtailimages:delete_upload_multiple';
    args: wagtailimages_delete_upload_multiple_args;
}

interface wagtailimages_delete_upload_multiple_args {
    uploaded_file_id: number;
}

interface wagtailsnippets_thelabui_labuitoolboxsnippet_list {
    name: 'wagtailsnippets_thelabui_labuitoolboxsnippet:list';
    args: wagtailsnippets_thelabui_labuitoolboxsnippet_list_args;
}

interface wagtailsnippets_thelabui_labuitoolboxsnippet_list_args {
}

interface wagtailsnippets_thelabui_labuitoolboxsnippet_list_results {
    name: 'wagtailsnippets_thelabui_labuitoolboxsnippet:list_results';
    args: wagtailsnippets_thelabui_labuitoolboxsnippet_list_results_args;
}

interface wagtailsnippets_thelabui_labuitoolboxsnippet_list_results_args {
}

interface wagtailsnippets_thelabui_labuitoolboxsnippet_add {
    name: 'wagtailsnippets_thelabui_labuitoolboxsnippet:add';
    args: wagtailsnippets_thelabui_labuitoolboxsnippet_add_args;
}

interface wagtailsnippets_thelabui_labuitoolboxsnippet_add_args {
}

interface wagtailsnippets_thelabui_labuitoolboxsnippet_edit {
    name: 'wagtailsnippets_thelabui_labuitoolboxsnippet:edit';
    args: wagtailsnippets_thelabui_labuitoolboxsnippet_edit_args;
}

interface wagtailsnippets_thelabui_labuitoolboxsnippet_edit_args {
    pk: string;
}

interface wagtailsnippets_thelabui_labuitoolboxsnippet_delete {
    name: 'wagtailsnippets_thelabui_labuitoolboxsnippet:delete';
    args: wagtailsnippets_thelabui_labuitoolboxsnippet_delete_args;
}

interface wagtailsnippets_thelabui_labuitoolboxsnippet_delete_args {
    pk: string;
}

interface wagtailsnippets_thelabui_labuitoolboxsnippet_usage {
    name: 'wagtailsnippets_thelabui_labuitoolboxsnippet:usage';
    args: wagtailsnippets_thelabui_labuitoolboxsnippet_usage_args;
}

interface wagtailsnippets_thelabui_labuitoolboxsnippet_usage_args {
    pk: string;
}

interface wagtailsnippets_thelabui_labuitoolboxsnippet_history {
    name: 'wagtailsnippets_thelabui_labuitoolboxsnippet:history';
    args: wagtailsnippets_thelabui_labuitoolboxsnippet_history_args;
}

interface wagtailsnippets_thelabui_labuitoolboxsnippet_history_args {
    pk: string;
}

interface wagtailsnippets_thelabui_labuitoolboxsnippet_history_results {
    name: 'wagtailsnippets_thelabui_labuitoolboxsnippet:history_results';
    args: wagtailsnippets_thelabui_labuitoolboxsnippet_history_results_args;
}

interface wagtailsnippets_thelabui_labuitoolboxsnippet_history_results_args {
    pk: string;
}

interface wagtailsnippets_thelabui_labuitoolboxsnippet_copy {
    name: 'wagtailsnippets_thelabui_labuitoolboxsnippet:copy';
    args: wagtailsnippets_thelabui_labuitoolboxsnippet_copy_args;
}

interface wagtailsnippets_thelabui_labuitoolboxsnippet_copy_args {
    pk: string;
}

interface wagtailsnippets_thelabui_labuitoolboxsnippet_preview_on_add {
    name: 'wagtailsnippets_thelabui_labuitoolboxsnippet:preview_on_add';
    args: wagtailsnippets_thelabui_labuitoolboxsnippet_preview_on_add_args;
}

interface wagtailsnippets_thelabui_labuitoolboxsnippet_preview_on_add_args {
}

interface wagtailsnippets_thelabui_labuitoolboxsnippet_preview_on_edit {
    name: 'wagtailsnippets_thelabui_labuitoolboxsnippet:preview_on_edit';
    args: wagtailsnippets_thelabui_labuitoolboxsnippet_preview_on_edit_args;
}

interface wagtailsnippets_thelabui_labuitoolboxsnippet_preview_on_edit_args {
    pk: string;
}

interface wagtailsnippets_thelabui_labuitoolboxsnippet_revisions_view {
    name: 'wagtailsnippets_thelabui_labuitoolboxsnippet:revisions_view';
    args: wagtailsnippets_thelabui_labuitoolboxsnippet_revisions_view_args;
}

interface wagtailsnippets_thelabui_labuitoolboxsnippet_revisions_view_args {
    pk: string;
    revision_id: number;
}

interface wagtailsnippets_thelabui_labuitoolboxsnippet_revisions_revert {
    name: 'wagtailsnippets_thelabui_labuitoolboxsnippet:revisions_revert';
    args: wagtailsnippets_thelabui_labuitoolboxsnippet_revisions_revert_args;
}

interface wagtailsnippets_thelabui_labuitoolboxsnippet_revisions_revert_args {
    pk: string;
    revision_id: number;
}

interface wagtailsnippets_thelabui_labuitoolboxsnippet_revisions_unschedule {
    name: 'wagtailsnippets_thelabui_labuitoolboxsnippet:revisions_unschedule';
    args: wagtailsnippets_thelabui_labuitoolboxsnippet_revisions_unschedule_args;
}

interface wagtailsnippets_thelabui_labuitoolboxsnippet_revisions_unschedule_args {
    pk: string;
    revision_id: number;
}

interface wagtailsnippets_thelabui_labuitoolboxsnippet_unpublish {
    name: 'wagtailsnippets_thelabui_labuitoolboxsnippet:unpublish';
    args: wagtailsnippets_thelabui_labuitoolboxsnippet_unpublish_args;
}

interface wagtailsnippets_thelabui_labuitoolboxsnippet_unpublish_args {
    pk: string;
}

interface wagtailsnippets_thelabui_labuitoolboxsnippet_lock {
    name: 'wagtailsnippets_thelabui_labuitoolboxsnippet:lock';
    args: wagtailsnippets_thelabui_labuitoolboxsnippet_lock_args;
}

interface wagtailsnippets_thelabui_labuitoolboxsnippet_lock_args {
    pk: string;
}

interface wagtailsnippets_thelabui_labuitoolboxsnippet_unlock {
    name: 'wagtailsnippets_thelabui_labuitoolboxsnippet:unlock';
    args: wagtailsnippets_thelabui_labuitoolboxsnippet_unlock_args;
}

interface wagtailsnippets_thelabui_labuitoolboxsnippet_unlock_args {
    pk: string;
}

interface wagtailsnippetchoosers_thelabui_labuitoolboxsnippet_choose {
    name: 'wagtailsnippetchoosers_thelabui_labuitoolboxsnippet:choose';
    args: wagtailsnippetchoosers_thelabui_labuitoolboxsnippet_choose_args;
}

interface wagtailsnippetchoosers_thelabui_labuitoolboxsnippet_choose_args {
}

interface wagtailsnippetchoosers_thelabui_labuitoolboxsnippet_choose_results {
    name: 'wagtailsnippetchoosers_thelabui_labuitoolboxsnippet:choose_results';
    args: wagtailsnippetchoosers_thelabui_labuitoolboxsnippet_choose_results_args;
}

interface wagtailsnippetchoosers_thelabui_labuitoolboxsnippet_choose_results_args {
}

interface wagtailsnippetchoosers_thelabui_labuitoolboxsnippet_chosen {
    name: 'wagtailsnippetchoosers_thelabui_labuitoolboxsnippet:chosen';
    args: wagtailsnippetchoosers_thelabui_labuitoolboxsnippet_chosen_args;
}

interface wagtailsnippetchoosers_thelabui_labuitoolboxsnippet_chosen_args {
    pk: string;
}

interface wagtailsnippetchoosers_thelabui_labuitoolboxsnippet_chosen_multiple {
    name: 'wagtailsnippetchoosers_thelabui_labuitoolboxsnippet:chosen_multiple';
    args: wagtailsnippetchoosers_thelabui_labuitoolboxsnippet_chosen_multiple_args;
}

interface wagtailsnippetchoosers_thelabui_labuitoolboxsnippet_chosen_multiple_args {
}

interface wagtailsnippetchoosers_thelabui_labuitoolboxsnippet_create {
    name: 'wagtailsnippetchoosers_thelabui_labuitoolboxsnippet:create';
    args: wagtailsnippetchoosers_thelabui_labuitoolboxsnippet_create_args;
}

interface wagtailsnippetchoosers_thelabui_labuitoolboxsnippet_create_args {
}

interface wagtailsnippets_locations_country_list {
    name: 'wagtailsnippets_locations_country:list';
    args: wagtailsnippets_locations_country_list_args;
}

interface wagtailsnippets_locations_country_list_args {
}

interface wagtailsnippets_locations_country_list_results {
    name: 'wagtailsnippets_locations_country:list_results';
    args: wagtailsnippets_locations_country_list_results_args;
}

interface wagtailsnippets_locations_country_list_results_args {
}

interface wagtailsnippets_locations_country_add {
    name: 'wagtailsnippets_locations_country:add';
    args: wagtailsnippets_locations_country_add_args;
}

interface wagtailsnippets_locations_country_add_args {
}

interface wagtailsnippets_locations_country_edit {
    name: 'wagtailsnippets_locations_country:edit';
    args: wagtailsnippets_locations_country_edit_args;
}

interface wagtailsnippets_locations_country_edit_args {
    pk: string;
}

interface wagtailsnippets_locations_country_delete {
    name: 'wagtailsnippets_locations_country:delete';
    args: wagtailsnippets_locations_country_delete_args;
}

interface wagtailsnippets_locations_country_delete_args {
    pk: string;
}

interface wagtailsnippets_locations_country_usage {
    name: 'wagtailsnippets_locations_country:usage';
    args: wagtailsnippets_locations_country_usage_args;
}

interface wagtailsnippets_locations_country_usage_args {
    pk: string;
}

interface wagtailsnippets_locations_country_history {
    name: 'wagtailsnippets_locations_country:history';
    args: wagtailsnippets_locations_country_history_args;
}

interface wagtailsnippets_locations_country_history_args {
    pk: string;
}

interface wagtailsnippets_locations_country_history_results {
    name: 'wagtailsnippets_locations_country:history_results';
    args: wagtailsnippets_locations_country_history_results_args;
}

interface wagtailsnippets_locations_country_history_results_args {
    pk: string;
}

interface wagtailsnippets_locations_country_copy {
    name: 'wagtailsnippets_locations_country:copy';
    args: wagtailsnippets_locations_country_copy_args;
}

interface wagtailsnippets_locations_country_copy_args {
    pk: string;
}

interface wagtailsnippetchoosers_locations_country_choose {
    name: 'wagtailsnippetchoosers_locations_country:choose';
    args: wagtailsnippetchoosers_locations_country_choose_args;
}

interface wagtailsnippetchoosers_locations_country_choose_args {
}

interface wagtailsnippetchoosers_locations_country_choose_results {
    name: 'wagtailsnippetchoosers_locations_country:choose_results';
    args: wagtailsnippetchoosers_locations_country_choose_results_args;
}

interface wagtailsnippetchoosers_locations_country_choose_results_args {
}

interface wagtailsnippetchoosers_locations_country_chosen {
    name: 'wagtailsnippetchoosers_locations_country:chosen';
    args: wagtailsnippetchoosers_locations_country_chosen_args;
}

interface wagtailsnippetchoosers_locations_country_chosen_args {
    pk: string;
}

interface wagtailsnippetchoosers_locations_country_chosen_multiple {
    name: 'wagtailsnippetchoosers_locations_country:chosen_multiple';
    args: wagtailsnippetchoosers_locations_country_chosen_multiple_args;
}

interface wagtailsnippetchoosers_locations_country_chosen_multiple_args {
}

interface wagtailsnippetchoosers_locations_country_create {
    name: 'wagtailsnippetchoosers_locations_country:create';
    args: wagtailsnippetchoosers_locations_country_create_args;
}

interface wagtailsnippetchoosers_locations_country_create_args {
}

interface wagtailsnippets_cms_tierednav_list {
    name: 'wagtailsnippets_cms_tierednav:list';
    args: wagtailsnippets_cms_tierednav_list_args;
}

interface wagtailsnippets_cms_tierednav_list_args {
}

interface wagtailsnippets_cms_tierednav_list_results {
    name: 'wagtailsnippets_cms_tierednav:list_results';
    args: wagtailsnippets_cms_tierednav_list_results_args;
}

interface wagtailsnippets_cms_tierednav_list_results_args {
}

interface wagtailsnippets_cms_tierednav_add {
    name: 'wagtailsnippets_cms_tierednav:add';
    args: wagtailsnippets_cms_tierednav_add_args;
}

interface wagtailsnippets_cms_tierednav_add_args {
}

interface wagtailsnippets_cms_tierednav_edit {
    name: 'wagtailsnippets_cms_tierednav:edit';
    args: wagtailsnippets_cms_tierednav_edit_args;
}

interface wagtailsnippets_cms_tierednav_edit_args {
    pk: string;
}

interface wagtailsnippets_cms_tierednav_delete {
    name: 'wagtailsnippets_cms_tierednav:delete';
    args: wagtailsnippets_cms_tierednav_delete_args;
}

interface wagtailsnippets_cms_tierednav_delete_args {
    pk: string;
}

interface wagtailsnippets_cms_tierednav_usage {
    name: 'wagtailsnippets_cms_tierednav:usage';
    args: wagtailsnippets_cms_tierednav_usage_args;
}

interface wagtailsnippets_cms_tierednav_usage_args {
    pk: string;
}

interface wagtailsnippets_cms_tierednav_history {
    name: 'wagtailsnippets_cms_tierednav:history';
    args: wagtailsnippets_cms_tierednav_history_args;
}

interface wagtailsnippets_cms_tierednav_history_args {
    pk: string;
}

interface wagtailsnippets_cms_tierednav_history_results {
    name: 'wagtailsnippets_cms_tierednav:history_results';
    args: wagtailsnippets_cms_tierednav_history_results_args;
}

interface wagtailsnippets_cms_tierednav_history_results_args {
    pk: string;
}

interface wagtailsnippets_cms_tierednav_copy {
    name: 'wagtailsnippets_cms_tierednav:copy';
    args: wagtailsnippets_cms_tierednav_copy_args;
}

interface wagtailsnippets_cms_tierednav_copy_args {
    pk: string;
}

interface wagtailsnippetchoosers_cms_tierednav_choose {
    name: 'wagtailsnippetchoosers_cms_tierednav:choose';
    args: wagtailsnippetchoosers_cms_tierednav_choose_args;
}

interface wagtailsnippetchoosers_cms_tierednav_choose_args {
}

interface wagtailsnippetchoosers_cms_tierednav_choose_results {
    name: 'wagtailsnippetchoosers_cms_tierednav:choose_results';
    args: wagtailsnippetchoosers_cms_tierednav_choose_results_args;
}

interface wagtailsnippetchoosers_cms_tierednav_choose_results_args {
}

interface wagtailsnippetchoosers_cms_tierednav_chosen {
    name: 'wagtailsnippetchoosers_cms_tierednav:chosen';
    args: wagtailsnippetchoosers_cms_tierednav_chosen_args;
}

interface wagtailsnippetchoosers_cms_tierednav_chosen_args {
    pk: string;
}

interface wagtailsnippetchoosers_cms_tierednav_chosen_multiple {
    name: 'wagtailsnippetchoosers_cms_tierednav:chosen_multiple';
    args: wagtailsnippetchoosers_cms_tierednav_chosen_multiple_args;
}

interface wagtailsnippetchoosers_cms_tierednav_chosen_multiple_args {
}

interface wagtailsnippetchoosers_cms_tierednav_create {
    name: 'wagtailsnippetchoosers_cms_tierednav:create';
    args: wagtailsnippetchoosers_cms_tierednav_create_args;
}

interface wagtailsnippetchoosers_cms_tierednav_create_args {
}

interface wagtailsites_index {
    name: 'wagtailsites:index';
    args: wagtailsites_index_args;
}

interface wagtailsites_index_args {
}

interface wagtailsites_index_results {
    name: 'wagtailsites:index_results';
    args: wagtailsites_index_results_args;
}

interface wagtailsites_index_results_args {
}

interface wagtailsites_add {
    name: 'wagtailsites:add';
    args: wagtailsites_add_args;
}

interface wagtailsites_add_args {
}

interface wagtailsites_edit {
    name: 'wagtailsites:edit';
    args: wagtailsites_edit_args;
}

interface wagtailsites_edit_args {
    pk: string;
}

interface wagtailsites_delete {
    name: 'wagtailsites:delete';
    args: wagtailsites_delete_args;
}

interface wagtailsites_delete_args {
    pk: string;
}

interface wagtailsites_history {
    name: 'wagtailsites:history';
    args: wagtailsites_history_args;
}

interface wagtailsites_history_args {
    pk: string;
}

interface wagtailsites_history_results {
    name: 'wagtailsites:history_results';
    args: wagtailsites_history_results_args;
}

interface wagtailsites_history_results_args {
    pk: string;
}

interface wagtailsites_usage {
    name: 'wagtailsites:usage';
    args: wagtailsites_usage_args;
}

interface wagtailsites_usage_args {
    pk: string;
}

interface wagtailsites_copy {
    name: 'wagtailsites:copy';
    args: wagtailsites_copy_args;
}

interface wagtailsites_copy_args {
    pk: string;
}

interface wagtailusers_users_index {
    name: 'wagtailusers_users:index';
    args: wagtailusers_users_index_args;
}

interface wagtailusers_users_index_args {
}

interface wagtailusers_users_index_results {
    name: 'wagtailusers_users:index_results';
    args: wagtailusers_users_index_results_args;
}

interface wagtailusers_users_index_results_args {
}

interface wagtailusers_users_add {
    name: 'wagtailusers_users:add';
    args: wagtailusers_users_add_args;
}

interface wagtailusers_users_add_args {
}

interface wagtailusers_users_edit {
    name: 'wagtailusers_users:edit';
    args: wagtailusers_users_edit_args;
}

interface wagtailusers_users_edit_args {
    pk: string;
}

interface wagtailusers_users_delete {
    name: 'wagtailusers_users:delete';
    args: wagtailusers_users_delete_args;
}

interface wagtailusers_users_delete_args {
    pk: string;
}

interface wagtailusers_users_history {
    name: 'wagtailusers_users:history';
    args: wagtailusers_users_history_args;
}

interface wagtailusers_users_history_args {
    pk: string;
}

interface wagtailusers_users_history_results {
    name: 'wagtailusers_users:history_results';
    args: wagtailusers_users_history_results_args;
}

interface wagtailusers_users_history_results_args {
    pk: string;
}

interface wagtailusers_users_usage {
    name: 'wagtailusers_users:usage';
    args: wagtailusers_users_usage_args;
}

interface wagtailusers_users_usage_args {
    pk: string;
}

interface wagtailusers_users_copy {
    name: 'wagtailusers_users:copy';
    args: wagtailusers_users_copy_args;
}

interface wagtailusers_users_copy_args {
    pk: string;
}

interface wagtailusers_groups_index {
    name: 'wagtailusers_groups:index';
    args: wagtailusers_groups_index_args;
}

interface wagtailusers_groups_index_args {
}

interface wagtailusers_groups_index_results {
    name: 'wagtailusers_groups:index_results';
    args: wagtailusers_groups_index_results_args;
}

interface wagtailusers_groups_index_results_args {
}

interface wagtailusers_groups_add {
    name: 'wagtailusers_groups:add';
    args: wagtailusers_groups_add_args;
}

interface wagtailusers_groups_add_args {
}

interface wagtailusers_groups_edit {
    name: 'wagtailusers_groups:edit';
    args: wagtailusers_groups_edit_args;
}

interface wagtailusers_groups_edit_args {
    pk: string;
}

interface wagtailusers_groups_delete {
    name: 'wagtailusers_groups:delete';
    args: wagtailusers_groups_delete_args;
}

interface wagtailusers_groups_delete_args {
    pk: string;
}

interface wagtailusers_groups_history {
    name: 'wagtailusers_groups:history';
    args: wagtailusers_groups_history_args;
}

interface wagtailusers_groups_history_args {
    pk: string;
}

interface wagtailusers_groups_history_results {
    name: 'wagtailusers_groups:history_results';
    args: wagtailusers_groups_history_results_args;
}

interface wagtailusers_groups_history_results_args {
    pk: string;
}

interface wagtailusers_groups_usage {
    name: 'wagtailusers_groups:usage';
    args: wagtailusers_groups_usage_args;
}

interface wagtailusers_groups_usage_args {
    pk: string;
}

interface wagtaildocs_chooser_choose {
    name: 'wagtaildocs_chooser:choose';
    args: wagtaildocs_chooser_choose_args;
}

interface wagtaildocs_chooser_choose_args {
}

interface wagtaildocs_chooser_choose_results {
    name: 'wagtaildocs_chooser:choose_results';
    args: wagtaildocs_chooser_choose_results_args;
}

interface wagtaildocs_chooser_choose_results_args {
}

interface wagtaildocs_chooser_chosen {
    name: 'wagtaildocs_chooser:chosen';
    args: wagtaildocs_chooser_chosen_args;
}

interface wagtaildocs_chooser_chosen_args {
    pk: string;
}

interface wagtaildocs_chooser_chosen_multiple {
    name: 'wagtaildocs_chooser:chosen_multiple';
    args: wagtaildocs_chooser_chosen_multiple_args;
}

interface wagtaildocs_chooser_chosen_multiple_args {
}

interface wagtaildocs_chooser_create {
    name: 'wagtaildocs_chooser:create';
    args: wagtaildocs_chooser_create_args;
}

interface wagtaildocs_chooser_create_args {
}

interface wagtailimages_chooser_choose {
    name: 'wagtailimages_chooser:choose';
    args: wagtailimages_chooser_choose_args;
}

interface wagtailimages_chooser_choose_args {
}

interface wagtailimages_chooser_choose_results {
    name: 'wagtailimages_chooser:choose_results';
    args: wagtailimages_chooser_choose_results_args;
}

interface wagtailimages_chooser_choose_results_args {
}

interface wagtailimages_chooser_chosen {
    name: 'wagtailimages_chooser:chosen';
    args: wagtailimages_chooser_chosen_args;
}

interface wagtailimages_chooser_chosen_args {
    pk: string;
}

interface wagtailimages_chooser_chosen_multiple {
    name: 'wagtailimages_chooser:chosen_multiple';
    args: wagtailimages_chooser_chosen_multiple_args;
}

interface wagtailimages_chooser_chosen_multiple_args {
}

interface wagtailimages_chooser_create {
    name: 'wagtailimages_chooser:create';
    args: wagtailimages_chooser_create_args;
}

interface wagtailimages_chooser_create_args {
}

interface wagtailimages_chooser_select_format {
    name: 'wagtailimages_chooser:select_format';
    args: wagtailimages_chooser_select_format_args;
}

interface wagtailimages_chooser_select_format_args {
    image_id: number;
}

interface wagtailvideos_chooser_choose {
    name: 'wagtailvideos_chooser:choose';
    args: wagtailvideos_chooser_choose_args;
}

interface wagtailvideos_chooser_choose_args {
}

interface wagtailvideos_chooser_choose_results {
    name: 'wagtailvideos_chooser:choose_results';
    args: wagtailvideos_chooser_choose_results_args;
}

interface wagtailvideos_chooser_choose_results_args {
}

interface wagtailvideos_chooser_chosen {
    name: 'wagtailvideos_chooser:chosen';
    args: wagtailvideos_chooser_chosen_args;
}

interface wagtailvideos_chooser_chosen_args {
    pk: string;
}

interface wagtailvideos_chooser_chosen_multiple {
    name: 'wagtailvideos_chooser:chosen_multiple';
    args: wagtailvideos_chooser_chosen_multiple_args;
}

interface wagtailvideos_chooser_chosen_multiple_args {
}

interface wagtailvideos_chooser_create {
    name: 'wagtailvideos_chooser:create';
    args: wagtailvideos_chooser_create_args;
}

interface wagtailvideos_chooser_create_args {
}

interface wagtailvideos_add {
    name: 'wagtailvideos:add';
    args: wagtailvideos_add_args;
}

interface wagtailvideos_add_args {
}

interface wagtailvideos_add_multiple {
    name: 'wagtailvideos:add_multiple';
    args: wagtailvideos_add_multiple_args;
}

interface wagtailvideos_add_multiple_args {
}

interface wagtailvideos_edit_multiple {
    name: 'wagtailvideos:edit_multiple';
    args: wagtailvideos_edit_multiple_args;
}

interface wagtailvideos_edit_multiple_args {
    video_id: number;
}

interface wagtailvideos_create_multiple_from_uploaded_image {
    name: 'wagtailvideos:create_multiple_from_uploaded_image';
    args: wagtailvideos_create_multiple_from_uploaded_image_args;
}

interface wagtailvideos_create_multiple_from_uploaded_image_args {
    uploaded_file_id: number;
}

interface wagtailvideos_delete_multiple {
    name: 'wagtailvideos:delete_multiple';
    args: wagtailvideos_delete_multiple_args;
}

interface wagtailvideos_delete_multiple_args {
    video_id: number;
}

interface wagtailvideos_delete_upload_multiple {
    name: 'wagtailvideos:delete_upload_multiple';
    args: wagtailvideos_delete_upload_multiple_args;
}

interface wagtailvideos_delete_upload_multiple_args {
    uploaded_file_id: number;
}

interface wagtailvideos_index {
    name: 'wagtailvideos:index';
    args: wagtailvideos_index_args;
}

interface wagtailvideos_index_args {
}

interface wagtailvideos_index_results {
    name: 'wagtailvideos:index_results';
    args: wagtailvideos_index_results_args;
}

interface wagtailvideos_index_results_args {
}

interface wagtail_modeladmin_javascript_catalog {
    name: 'wagtail_modeladmin:javascript_catalog';
    args: wagtail_modeladmin_javascript_catalog_args;
}

interface wagtail_modeladmin_javascript_catalog_args {
}

interface wagtailadmin_sprite {
    name: 'wagtailadmin_sprite';
    args: wagtailadmin_sprite_args;
}

interface wagtailadmin_sprite_args {
}

interface wagtailadmin_login {
    name: 'wagtailadmin_login';
    args: wagtailadmin_login_args;
}

interface wagtailadmin_login_args {
}

interface wagtailadmin_password_reset {
    name: 'wagtailadmin_password_reset';
    args: wagtailadmin_password_reset_args;
}

interface wagtailadmin_password_reset_args {
}

interface wagtailadmin_password_reset_done {
    name: 'wagtailadmin_password_reset_done';
    args: wagtailadmin_password_reset_done_args;
}

interface wagtailadmin_password_reset_done_args {
}

interface wagtailadmin_password_reset_confirm {
    name: 'wagtailadmin_password_reset_confirm';
    args: wagtailadmin_password_reset_confirm_args;
}

interface wagtailadmin_password_reset_confirm_args {
    uidb64: string;
    token: string;
}

interface wagtailadmin_password_reset_complete {
    name: 'wagtailadmin_password_reset_complete';
    args: wagtailadmin_password_reset_complete_args;
}

interface wagtailadmin_password_reset_complete_args {
}

interface wagtailadmin_javascript_catalog {
    name: 'wagtailadmin_javascript_catalog';
    args: wagtailadmin_javascript_catalog_args;
}

interface wagtailadmin_javascript_catalog_args {
}

interface health_check_health_check_home {
    name: 'health_check:health_check_home';
    args: health_check_health_check_home_args;
}

interface health_check_health_check_home_args {
}

interface health_check_health_check_subset {
    name: 'health_check:health_check_subset';
    args: health_check_health_check_subset_args;
}

interface health_check_health_check_subset_args {
    subset: string;
}

interface locations_api_locationlist {
    name: 'locations-api:locationlist';
    args: locations_api_locationlist_args;
}

interface locations_api_locationlist_args {
}

interface locations_api_locationdetail {
    name: 'locations-api:locationdetail';
    args: locations_api_locationdetail_args;
}

interface locations_api_locationdetail_args {
}

interface locations_api_waitlistdetail {
    name: 'locations-api:waitlistdetail';
    args: locations_api_waitlistdetail_args;
}

interface locations_api_waitlistdetail_args {
}

interface locations_api_flush {
    name: 'locations-api:flush';
    args: locations_api_flush_args;
}

interface locations_api_flush_args {
}

interface locations_api_waitlist_join {
    name: 'locations-api:waitlist-join';
    args: locations_api_waitlist_join_args;
}

interface locations_api_waitlist_join_args {
}

interface locations_api_waitlist_getestimate {
    name: 'locations-api:waitlist-getestimate';
    args: locations_api_waitlist_getestimate_args;
}

interface locations_api_waitlist_getestimate_args {
}

interface locations_api_waitlist_entry {
    name: 'locations-api:waitlist-entry';
    args: locations_api_waitlist_entry_args;
}

interface locations_api_waitlist_entry_args {
    plan_ahead_id: string;
}

interface locations_api_locationlist_alt {
    name: 'locations-api:locationlist-alt';
    args: locations_api_locationlist_alt_args;
}

interface locations_api_locationlist_alt_args {
}

interface locations_api_locationdetail_alt {
    name: 'locations-api:locationdetail-alt';
    args: locations_api_locationdetail_alt_args;
}

interface locations_api_locationdetail_alt_args {
}

interface locations_api_waitlistdetail_alt {
    name: 'locations-api:waitlistdetail-alt';
    args: locations_api_waitlistdetail_alt_args;
}

interface locations_api_waitlistdetail_alt_args {
}

interface locations_api_flush_alt {
    name: 'locations-api:flush-alt';
    args: locations_api_flush_alt_args;
}

interface locations_api_flush_alt_args {
}

interface locations_api_waitlist_join_alt {
    name: 'locations-api:waitlist-join-alt';
    args: locations_api_waitlist_join_alt_args;
}

interface locations_api_waitlist_join_alt_args {
}

interface locations_api_waitlist_getestimate_alt {
    name: 'locations-api:waitlist-getestimate-alt';
    args: locations_api_waitlist_getestimate_alt_args;
}

interface locations_api_waitlist_getestimate_alt_args {
}

interface locations_api_waitlist_entry_alt {
    name: 'locations-api:waitlist-entry-alt';
    args: locations_api_waitlist_entry_alt_args;
}

interface locations_api_waitlist_entry_alt_args {
    plan_ahead_id: string;
}

interface locations_locationredirect {
    name: 'locations:locationredirect';
    args: locations_locationredirect_args;
}

interface locations_locationredirect_args {
    state_slug: string;
    city_slug: string;
    line1_slug: string;
}

interface api_fcc_unsubscribe {
    name: 'api-fcc-unsubscribe';
    args: api_fcc_unsubscribe_args;
}

interface api_fcc_unsubscribe_args {
}

interface site_footer {
    name: 'site-footer';
    args: site_footer_args;
}

interface site_footer_args {
}

interface videotrack_serve {
    name: 'videotrack-serve';
    args: videotrack_serve_args;
}

interface videotrack_serve_args {
    pk: number;
}

interface error_404 {
    name: 'error-404';
    args: error_404_args;
}

interface error_404_args {
}

interface integration_manifest {
    name: 'integration-manifest';
    args: integration_manifest_args;
}

interface integration_manifest_args {
}

interface google_verification {
    name: 'google-verification';
    args: google_verification_args;
}

interface google_verification_args {
}

interface wagtailcore_authenticate_with_password {
    name: 'wagtailcore_authenticate_with_password';
    args: wagtailcore_authenticate_with_password_args;
}

interface wagtailcore_authenticate_with_password_args {
    page_view_restriction_id: number;
    page_id: number;
}

interface wagtailcore_login {
    name: 'wagtailcore_login';
    args: wagtailcore_login_args;
}

interface wagtailcore_login_args {
}

interface __reactivated_do_not_use {
    name: '__reactivated_do_not_use';
    args: __reactivated_do_not_use_args;
}

interface __reactivated_do_not_use_args {
}

interface __reactivated_do_not_use_args {
    name: '__reactivated_do_not_use_args';
    args: __reactivated_do_not_use_args_args;
}

interface __reactivated_do_not_use_args_args {
    _: string;
}

type WithArguments = |wagtailadmin_api_pages_detail|wagtailadmin_api_pages_action|wagtailadmin_api_documents_detail|wagtailadmin_api_images_detail|wagtailadmin_explore|wagtailadmin_explore_results|wagtail_bulk_action|wagtailadmin_pages_add|wagtailadmin_pages_preview_on_add|wagtailadmin_pages_type_use|wagtailadmin_pages_type_use_results|wagtailadmin_pages_usage|wagtailadmin_pages_edit|wagtailadmin_pages_preview_on_edit|wagtailadmin_pages_view_draft|wagtailadmin_pages_add_subpage|wagtailadmin_pages_delete|wagtailadmin_pages_unpublish|wagtailadmin_pages_convert_alias|wagtailadmin_pages_move|wagtailadmin_pages_move_confirm|wagtailadmin_pages_set_page_position|wagtailadmin_pages_copy|wagtailadmin_pages_workflow_action|wagtailadmin_pages_collect_workflow_action_data|wagtailadmin_pages_confirm_workflow_cancellation|wagtailadmin_pages_workflow_preview|wagtailadmin_pages_set_privacy|wagtailadmin_pages_lock|wagtailadmin_pages_unlock|wagtailadmin_pages_revisions_index|wagtailadmin_pages_revisions_view|wagtailadmin_pages_revisions_revert|wagtailadmin_pages_revisions_unschedule|wagtailadmin_pages_workflow_history|wagtailadmin_pages_workflow_history_detail|wagtailadmin_pages_history|wagtailadmin_pages_history_results|wagtailadmin_choose_page_child|wagtailadmin_tag_model_autocomplete|wagtailadmin_collections_edit|wagtailadmin_collections_delete|wagtailadmin_collections_set_privacy|wagtailadmin_workflows_enable|wagtailadmin_workflows_disable|wagtailadmin_workflows_edit|wagtailadmin_workflows_usage|wagtailadmin_workflows_usage_results|wagtailadmin_workflows_remove|wagtailadmin_workflows_add_task|wagtailadmin_workflows_edit_task|wagtailadmin_workflows_disable_task|wagtailadmin_workflows_enable_task|wagtailadmin_workflows_task_chosen|wagtailadmin_editing_sessions_ping|wagtailadmin_editing_sessions_release|wagtailforms_list_submissions|wagtailforms_list_submissions_results|wagtailforms_delete_submissions|wagtailredirects_edit|wagtailredirects_delete|wagtailsettings_edit|wagtaildocs_edit|wagtaildocs_delete|wagtaildocs_edit_multiple|wagtaildocs_create_multiple_from_uploaded_document|wagtaildocs_delete_multiple|wagtaildocs_delete_upload_multiple|wagtaildocs_document_usage|wagtailimages_edit|wagtailimages_delete|wagtailimages_url_generator|wagtailimages_generate_url|wagtailimages_preview|wagtailimages_image_usage|wagtailimages_edit_multiple|wagtailimages_create_multiple_from_uploaded_image|wagtailimages_delete_multiple|wagtailimages_delete_upload_multiple|wagtailsnippets_thelabui_labuitoolboxsnippet_edit|wagtailsnippets_thelabui_labuitoolboxsnippet_delete|wagtailsnippets_thelabui_labuitoolboxsnippet_usage|wagtailsnippets_thelabui_labuitoolboxsnippet_history|wagtailsnippets_thelabui_labuitoolboxsnippet_history_results|wagtailsnippets_thelabui_labuitoolboxsnippet_copy|wagtailsnippets_thelabui_labuitoolboxsnippet_preview_on_edit|wagtailsnippets_thelabui_labuitoolboxsnippet_revisions_view|wagtailsnippets_thelabui_labuitoolboxsnippet_revisions_revert|wagtailsnippets_thelabui_labuitoolboxsnippet_revisions_unschedule|wagtailsnippets_thelabui_labuitoolboxsnippet_unpublish|wagtailsnippets_thelabui_labuitoolboxsnippet_lock|wagtailsnippets_thelabui_labuitoolboxsnippet_unlock|wagtailsnippetchoosers_thelabui_labuitoolboxsnippet_chosen|wagtailsnippets_locations_country_edit|wagtailsnippets_locations_country_delete|wagtailsnippets_locations_country_usage|wagtailsnippets_locations_country_history|wagtailsnippets_locations_country_history_results|wagtailsnippets_locations_country_copy|wagtailsnippetchoosers_locations_country_chosen|wagtailsnippets_cms_tierednav_edit|wagtailsnippets_cms_tierednav_delete|wagtailsnippets_cms_tierednav_usage|wagtailsnippets_cms_tierednav_history|wagtailsnippets_cms_tierednav_history_results|wagtailsnippets_cms_tierednav_copy|wagtailsnippetchoosers_cms_tierednav_chosen|wagtailsites_edit|wagtailsites_delete|wagtailsites_history|wagtailsites_history_results|wagtailsites_usage|wagtailsites_copy|wagtailusers_users_edit|wagtailusers_users_delete|wagtailusers_users_history|wagtailusers_users_history_results|wagtailusers_users_usage|wagtailusers_users_copy|wagtailusers_groups_edit|wagtailusers_groups_delete|wagtailusers_groups_history|wagtailusers_groups_history_results|wagtailusers_groups_usage|wagtaildocs_chooser_chosen|wagtailimages_chooser_chosen|wagtailimages_chooser_select_format|wagtailvideos_chooser_chosen|wagtailvideos_edit_multiple|wagtailvideos_create_multiple_from_uploaded_image|wagtailvideos_delete_multiple|wagtailvideos_delete_upload_multiple|wagtailadmin_password_reset_confirm|health_check_health_check_subset|locations_api_waitlist_entry|locations_api_waitlist_entry_alt|locations_locationredirect|videotrack_serve|wagtailcore_authenticate_with_password|__reactivated_do_not_use_args;
type WithoutArguments = |sitemap|sitemap_index|thelabui_load_balancer_health_check|thelabui_csrftoken_get|thelabui_robots_txt|thelabui_security_txt|thelabui_sitemap|wagtailadmin_home|wagtailadmin_api_pages_listing|wagtailadmin_api_pages_find|wagtailadmin_api_documents_listing|wagtailadmin_api_documents_find|wagtailadmin_api_images_listing|wagtailadmin_api_images_find|wagtailadmin_error_test|wagtailadmin_explore_root|wagtailadmin_pages_search|wagtailadmin_pages_search_results|wagtailadmin_choose_page|wagtailadmin_choose_page_search|wagtailadmin_choose_page_chosen_multiple|wagtailadmin_choose_page_external_link|wagtailadmin_choose_page_email_link|wagtailadmin_choose_page_phone_link|wagtailadmin_choose_page_anchor_link|wagtailadmin_tag_autocomplete|wagtailadmin_collections_index|wagtailadmin_collections_add|wagtailadmin_workflows_index|wagtailadmin_workflows_index_results|wagtailadmin_workflows_add|wagtailadmin_workflows_select_task_type|wagtailadmin_workflows_task_index|wagtailadmin_workflows_task_index_results|wagtailadmin_workflows_task_chooser|wagtailadmin_workflows_task_chooser_results|wagtailadmin_workflows_task_chooser_create|wagtailadmin_reports_locked_pages|wagtailadmin_reports_locked_pages_results|wagtailadmin_reports_workflow|wagtailadmin_reports_workflow_results|wagtailadmin_reports_workflow_tasks|wagtailadmin_reports_workflow_tasks_results|wagtailadmin_reports_site_history|wagtailadmin_reports_site_history_results|wagtailadmin_reports_aging_pages|wagtailadmin_reports_aging_pages_results|wagtailadmin_reports_page_types_usage|wagtailadmin_reports_page_types_usage_results|wagtailadmin_account|wagtailadmin_logout|wagtailadmin_dismissibles|wagtailadmin_block_preview|wagtailforms_index|wagtailforms_index_results|wagtailredirects_index|wagtailredirects_index_results|wagtailredirects_add|wagtailredirects_start_import|wagtailredirects_process_import|wagtailstyleguide|wagtailembeds_chooser|wagtailembeds_chooser_upload|wagtailsnippets_index|wagtaildocs_index|wagtaildocs_index_results|wagtaildocs_add|wagtaildocs_add_multiple|wagtailimages_index|wagtailimages_index_results|wagtailimages_add|wagtailimages_add_multiple|wagtailsnippets_thelabui_labuitoolboxsnippet_list|wagtailsnippets_thelabui_labuitoolboxsnippet_list_results|wagtailsnippets_thelabui_labuitoolboxsnippet_add|wagtailsnippets_thelabui_labuitoolboxsnippet_preview_on_add|wagtailsnippetchoosers_thelabui_labuitoolboxsnippet_choose|wagtailsnippetchoosers_thelabui_labuitoolboxsnippet_choose_results|wagtailsnippetchoosers_thelabui_labuitoolboxsnippet_chosen_multiple|wagtailsnippetchoosers_thelabui_labuitoolboxsnippet_create|wagtailsnippets_locations_country_list|wagtailsnippets_locations_country_list_results|wagtailsnippets_locations_country_add|wagtailsnippetchoosers_locations_country_choose|wagtailsnippetchoosers_locations_country_choose_results|wagtailsnippetchoosers_locations_country_chosen_multiple|wagtailsnippetchoosers_locations_country_create|wagtailsnippets_cms_tierednav_list|wagtailsnippets_cms_tierednav_list_results|wagtailsnippets_cms_tierednav_add|wagtailsnippetchoosers_cms_tierednav_choose|wagtailsnippetchoosers_cms_tierednav_choose_results|wagtailsnippetchoosers_cms_tierednav_chosen_multiple|wagtailsnippetchoosers_cms_tierednav_create|wagtailsites_index|wagtailsites_index_results|wagtailsites_add|wagtailusers_users_index|wagtailusers_users_index_results|wagtailusers_users_add|wagtailusers_groups_index|wagtailusers_groups_index_results|wagtailusers_groups_add|wagtaildocs_chooser_choose|wagtaildocs_chooser_choose_results|wagtaildocs_chooser_chosen_multiple|wagtaildocs_chooser_create|wagtailimages_chooser_choose|wagtailimages_chooser_choose_results|wagtailimages_chooser_chosen_multiple|wagtailimages_chooser_create|wagtailvideos_chooser_choose|wagtailvideos_chooser_choose_results|wagtailvideos_chooser_chosen_multiple|wagtailvideos_chooser_create|wagtailvideos_add|wagtailvideos_add_multiple|wagtailvideos_index|wagtailvideos_index_results|wagtail_modeladmin_javascript_catalog|wagtailadmin_sprite|wagtailadmin_login|wagtailadmin_password_reset|wagtailadmin_password_reset_done|wagtailadmin_password_reset_complete|wagtailadmin_javascript_catalog|health_check_health_check_home|locations_api_locationlist|locations_api_locationdetail|locations_api_waitlistdetail|locations_api_flush|locations_api_waitlist_join|locations_api_waitlist_getestimate|locations_api_locationlist_alt|locations_api_locationdetail_alt|locations_api_waitlistdetail_alt|locations_api_flush_alt|locations_api_waitlist_join_alt|locations_api_waitlist_getestimate_alt|api_fcc_unsubscribe|site_footer|error_404|integration_manifest|google_verification|wagtailcore_login|__reactivated_do_not_use;


    type All = WithArguments|WithoutArguments;
    export function reverse<T extends WithoutArguments['name']>(name: T): string;
    export function reverse<T extends WithArguments['name']>(name: T, args: Extract<WithArguments, {name: T}>['args']): string;
    export function reverse<T extends All['name']>(name: T, args?: Extract<WithArguments, {name: T}>['args']): string {
        let route = urls[name].route;

        if (args != null) {
            for (const token of Object.keys(args)) {
                route = route.replace(new RegExp('<(.+?:)' + token + '>'), (args as any)[token]);
            }
        }
        return route;
    }
